
export const userTermsContent = `مَهمة تدرب الأساسية هي تحسين الحياة من خلال التعلم؛ ولهذا يعمل فريقنا من تمكين أي شخص في أي مكان من إنشاء ومشاركة المحتوى التعليمي - والذي يتمثل في المدربين والخبراء ، والوصول إلى هذا المحتوى التعليمي للتعلم – والذي يتمثل في المستخدم.
 
منصة تدرب، الأفضل في الخليج والشرق الاوسط لتقديم محتوى تعليمي قيم للمستخدمين؛ وهذا ما يجعلنا في حاجة إلى إرساء قواعد للحفاظ على نظامنا الأساسي وخدماتنا آمنة للمستخدمين وللمنصة.
 
وهذه الشروط تنطبق على جميع الأنشطة على منصة تدرب وتطبيق تدرب للهواتف الجوالة وواجهات برمجة التطبيقات الخاصة بنا، والخدمات الأخرى ذات الصلة والتي تتضمن الخدمات التي تقدمها المنصة لمُستخدميها.
 
إذا قمتَ بنشر دورة تدريبية على منصة تدرب؛ فيجب عليك أيضاً الموافقة على شروط المدرب؛ حيث إننا نُقدم تفاصيل تتعلق بمعالجتنا للبيانات الشخصية لطلابنا ومعلمينا في سياسة الخصوصية الخاصة بنا.`;

export const termsAndConditionsListItems = [
  "الحسابات",
  "تسجيل المحتوى والوصول مدى الحياة",
  "المدفوعات والاعتمادات والمبالغ المستردة",
  "قواعد المحتوى والسلوك",
  "حقوق تدرب في المحتوى الذي تنشره",
  "استخدام تدرب على مسؤوليتك الخاصة",
  "حقوق تدرب",
  "شروط نظم الاشتراكات",
  "شروط قانونية متنوعة",
  "تسوية المنازعات",
  "تحديث هذه الشروط",
  "كيفية الاتصال بنا",
];

export const instructorTermsAndConditionsListItems = [
  "التزامات المُدرِّب",
  "ترخيص تدرَّب",
  "الثقة والأمان",
  "التسعير",
  "المدفوعات",
  "سادساً العلامات التجارية",
  "تعطيل او حذف الحساب",
  "شروط قانونية متنوعة",
];

export const privacyTermsAndConditionsListItems = [
  "إستخدام المعلومات المجمعة",
  "االبيانات الشخصية",
  "من يطلع على بياناتك",
  "معلومات إضافية",
  "وقت تخزين تلك البيانات",
];

const cookiesListItems = [
  "ما هي ملفات تعريف الارتباط؟",
  "أنواع ملفات تعريف الارتباط",
  "ملفات تعريف الارتباط للطرف الأول",
  "ملفات تعريف ارتباط الطرف الثالث",
  "ملفات تعريف ارتباط الجلسة",
  "ملفات تعريف الارتباط الدائمة",
  "ملفات تعريف الارتباط الآمنة",
  "ملفات تعريف ارتباط HTTPOnly",
  "تقنيات التتبع عبر الإنترنت",
  "إشارات الإنترنت ووحدات البكسل",
  "البصمات",
  "ملف تعريف الأرتباط الفائق",
  "فوائد ملفات تعريف الارتباط",
  "تحليلات",
  "ملفات تعريف الارتباط والخصوصية عبر الإنترنت",
  "تخزين معلومات التعريف الشخصية",
  "تتبع سلوك المستخدم",
  "محتوى مجاني",
  "لائحة الخصوصية",
  "لا تتبع",
  "كيفية إدارة ملفات تعريف الارتباط",
];

export const termsAndConditions = [
  {
    type: "paragraph",
    content: userTermsContent,
  },
  {
    type: "titledList",
    title: "بنود شروط الاستخدام",
    items: termsAndConditionsListItems,
  },
  {
    type: "titleSubtitle",
    id: "الحسابات",
    title: "1- الحسابات",
    subtitle: ` كمستخدم لمنصة تدرب؛ تكون بحاجة إلى إنشاء حساب لمعظم الأنشطة عليها، ويجب أن تحتفظ بكلمة المرور في مكان آمن؛ لأنك مسؤول عن جميع الأنشطة المرتبطة بحسابك.
 
إذا كنت تشك في أن شخصاً آخر يستخدم حسابك؛ فأخبرنا عن طريق الاتصال بفريق الدعم لدينا.
 
يجب أن تكون قد وصلت إلى سن الموافقة على الخدمات عبر الإنترنت في بلدك لاستخدام منصة تدرب.
 
أنت بحاجة إلى حساب لمعظم الأنشطة على نظامنا الأساسي، والتي تتضمن شراء المحتوى والوصول إليه أو إرسال المحتوى للنشر.
 
عند إعداد حسابك وصيانته؛ يجب عليك تقديم معلومات دقيقة وكاملة والاستمرار في تقديمها، مُتضمنة عنوان بريد إلكتروني صالح.
 
أنت تتحمل المسؤولية الكاملة عن حسابك وكل ما يحدث عليه، بما في ذلك أي ضرر يلحق بك أو يلحق بمنصة تدرب أو يلحق بأي شخص آخر، والذي ينجم عن شخص يستخدم حسابك دون إذنك؛ مما يعني أنك بحاجة إلى توخي الحذر بشأن كلمة المرور الخاصة بك.
 
لا يجوز لك نقل حسابك إلى شخص آخر أو استخدام حساب شخص آخر، وإذا اتصلت بنا لطلب الوصول إلى حسابك؛ فلن نمنحك هذا الوصول، ما لم تتمكن من تزويدنا بالمعلومات التي نحتاجها لإثبات أنك مالك لهذا الحساب.
 
لا يجوز لك مشاركة بيانات اعتماد تسجيل الدخول إلى حسابك مع أي شخص آخر؛ فأنت مسؤول عما يحدث مع حسابك ولن تتدخل منصة تدرب في النزاعات بين الطلاب أو المدربين الذين شاركوا بيانات اعتماد تسجيل الدخول إلى الحساب.
 
يجب عليك إخطارنا فور علمك أن شخصًا آخر قد يستخدم حسابك دون إذنك، أو إذا كنت تشك في أي خرق آخر للأمن عن طريق الاتصال بفريق الدعم لدينا، وقد نطلب منك بعض المعلومات لتأكيد أنك مالك لحسابك بالفعل.
 
إذا كنت أقل من السن القانوني ١٦ عام على استخدام الخدمات عبر الإنترنت؛ فلا يجوز لك إنشاء حساب، وإذا اكتشفنا أنك أنشأت حساباً ينتهك هذه القواعد؛ فسيقوم فريق عملنا بإنهائه.
 
بموجب شروط المدرب الخاصة بنا؛ قد يُطلب منك التحقق من هويتك قبل أن يُسمح لك بإرسال محتوى للنشر على منصة تدرب.`,
  },
  {
    type: "titleSubtitle",
    id: "تسجيل المحتوى والوصول مدى الحياة",
    title: "2 - تسجيل المحتوى والوصول مدى الحياة",
    subtitle: ` عند التسجيل في دورة تدريبية أو أي محتوى آخر؛ فإنك تحصل على ترخيص من منصة تدرب لمشاهدته عبر خدماتها وليس لأي استخدام آخر؛ فلا تحاول نقل أو إعادة بيع المحتوى بأي شكل من الأشكال.
 
ونحن نمنحك على أي حال ترخيصاً بالوصول إلى المحتوى مدى الحياة، إلا عندما يتعين علينا تعطيل المحتوى لأسباب قانونية أو متعلقة بالسياسة أو للتسجيلات عبر خطط الاشتراك.
 
بموجب شروط المدرب الخاصة بمنصة تدرب، عندما ينشر المدربون محتوى عليها؛ فإنهم يمنحون تدرب ترخيصاً لتقديم ترخيص للمحتوى للطلاب؛ وهذا يعني أن لدينا الحق في ترخيص المحتوى للطلاب المسجلين.
 
كمستخدم عندما تسجل في دورة تدريبية أو أي محتوى آخر - سواء كان محتوى مجانياً أو مدفوعاً -؛ فإنك تحصل على ترخيص من تدرب لعرض المحتوى عبر منصتها وخدماتها.
 
وتدرب هي المُرخّص للسجل؛ مما يعني بأن المحتوى مرخص لك وليس ملكاً لك؛ فلا يمنحك هذا الترخيص أي حق في إعادة بيع المحتوى بأي طريقة؛ بما في ذلك مشاركة معلومات الحساب مع المشتري أو تنزيل المحتوى بشكل غير قانوني ومشاركته على المواقع الإلكترونية.
 
في الشروط القانونية الأكثر اكتمالا؛ تمنحك تدرب كطالب ترخيصاً محدوداً وغير حصري وغير قابل للتحويل؛ للوصول إلى المحتوى الذي دفعت مقابله جميع الرسوم المطلوبة وعرضه، فقط من أجلك بشكل شخصي وغير تجاري - والتي تتضمن الأغراض التعليمية من خلال الخدمات - وفقًا لهذه الشروط وأي شروط أو قيود مرتبطة بمحتوى أو مزايا معينة لخدماتنا.
 
جميع الاستخدامات الأخرى محظورة؛ فلا يجوز لك إعادة إنتاج أو إعادة توزيع أو نقل أو تخصيص أو بيع أو بث أو تأجير أو مشاركة أو إعارة أو تعديل أو تكييف أو تعديل أو إنشاء أعمال مشتقة من أي محتوى أو إعادة ترخيصه أو نقله أو استخدامه بأي طريقة أخرى، ما لم نمنحك إذناً صريحًا للقيام بذلك، في اتفاقية مكتوبة موقعة من قبل ممثل تدرب المفوض، وينطبق هذا أيضًا على المحتوى الذي يمكنك الوصول إليه عبر أي من واجهات برمجة التطبيقات الخاصة بنا.
 
نعطي عموماً ترخيص وصول مدى الحياة لطلابنا عند تسجيلهم في دورة تدريبية أو محتوى آخر، ومع ذلك؛ فإننا نحتفظ بالحق في إلغاء أي ترخيص للوصول إلى أي محتوى واستخدامه في أي وقت، في حال قررنا أو أصبحنا مُلزَمين بتعطيل الوصول إلى المحتوى لأسباب قانونية أو سياسية؛ فعلى سبيل المثال؛ إذا كانت الدورة التدريبية أو المحتوى الآخر الذي قمت بالتسجيل فيه موضوع شكوى بشأن حقوق الطبع والنشر، أو إذا قررنا أنه ينتهك إرشادات الثقة والأمان الخاصة بنا.
 
ولا ينطبق ترخيص الوصول مدى الحياة هذا على عمليات التسجيل عبر خطط الاشتراك أو المزايا والخدمات الإضافية المرتبطة بالدورة التدريبية أو المحتوى الآخر الذي تسجل فيه؛ فعلى سبيل المثال؛ قد يقرر المدرسون في أي وقت عدم تقديم المساعدة التعليمية أو خدمات الأسئلة والأجوبة في الارتباط بالمحتوى؛ فإن الوصول مدى الحياة يكون إلى محتوى الدورة التدريبية وليس إلى المدرب.
 
لا يجوز للمدربين منح تراخيص لمحتوياتهم للطلاب مباشرة، ويعتبر أي ترخيص مباشر من هذا القبيل لاغياً وباطلاً وينتهك هذه الشروط.`,
  },
  {
    type: "sectionNumbered",
    id: "المدفوعات والاعتمادات والمبالغ المستردة",
    title: "3 - المدفوعات والاعتمادات والمبالغ المستردة",
    subtitle: `عندما تقوم بالدفع؛ فإنك توافق على استخدام طريقة دفع صالحة، وإذا لم تكن راضياً عن المحتوى؛ فإن تدرب تقدم استرداداً أو رصيداً لمدة 30 يوماً لمعظم عمليات شراء المحتوى.`,
    subSections: [
      {
        title: "3.1 التسعير",
        subtitle: `يتم تحديد أسعار المحتوى على تدرب بناءً على شروط المدرب وسياسة العروض الترويجية الخاصة بنا، وفي بعض الحالات، قد لا يكون سعر المحتوى المعروض على موقع تدرب هو نفسه تمامًا السعر المعروض على تطبيقات الهاتف الجوال؛ نظرًا لأنظمة التسعير الخاصة بمزودي الأنظمة الأساسية للجوال وسياساتهم المتعلقة بتنفيذ المبيعات والعروض الترويجية.
 
نقوم أحياناً بتشغيل عروض ترويجية ومبيعات لمحتوياتنا، والتي يتوفر خلالها محتوى معين بأسعار مخفضة لفترة زمنية محددة، وسيكون السعر المطبق على المحتوى في هذه الحالة هو السعر في الوقت الذي تُكمل فيه شراء المحتوى عند تسجيل الخروج، وقد يختلف أيضاً أي سعر معروض لمحتوى معين عند تسجيل الدخول إلى حسابك عن السعر المتاح للمستخدمين غير المسجلين أو الذين قاموا بتسجيل الدخول؛ لأن بعض عروضنا الترويجية متاحة فقط للمستخدمين الجدد.
 
إذا قمت بتسجيل الدخول إلى حسابك؛ فإن العملة المدرجة التي تراها تستند إلى موقعك عندما أنشأت حسابك، وإذا لم تقم بتسجيل الدخول إلى حسابك؛ فإن عملة السعر تعتمد على البلد الذي تتواجد فيه؛ فنحن لا نُمكِّن المستخدمين من رؤية الأسعار بعملات أخرى.
 
إذا كنت طالباً مقيماً في بلد تسري فيه ضريبة الاستخدام والمبيعات أو ضريبة السلع والخدمات أو ضريبة القيمة المضافة على مبيعات المستهلكين؛ فنحن مسؤولون عن تحصيل تلك الضريبة وتحويلها إلى السلطات الضريبية المناسبة، واعتماداً على موقعك؛ فقد يشمل السعر الذي تراه مثل هذه الضرائب، أو قد يتم إضافة الضريبة عند تسجيل الخروج.`,
      },
      {
        title: "3.2 المدفوعات",
        subtitle: `أنت توافق على دفع رسوم المحتوى الذي تشتريه، وتفوضنا بتحصيل رسوم بطاقة الخصم أو الائتمان الخاصة بك أو معالجة وسائل الدفع الأخرى مثل Boleto أو SEPA أو الخصم المباشر أو محفظة الهاتف الجوال لتلك الرسوم.
 
وتعمل تدرب مع مزودي خدمة الدفع ليقدموا لك طرق الدفع الأكثر ملاءمة في بلدك وللحفاظ على معلومات الدفع الخاصة بك آمنة.
 
قد نقوم بتحديث طرق الدفع الخاصة بك باستخدام المعلومات المقدمة من قبل مزودي خدمة الدفع لدينا.
 
تحقق من سياسة الخصوصية الخاصة بنا للحصول على مزيد من التفاصيل.
 
عند إجراء عملية شراء؛ فإنك توافق على عدم استخدام طريقة دفع غير صالحة أو غير مصرح بها، وإذا فشلت طريقة الدفع الخاصة بك ولا يزال بإمكانك الوصول إلى المحتوى الذي تقوم بالتسجيل فيه؛ فإنك توافق على دفع الرسوم المقابلة لنا في غضون 30 يوماً من إخطارنا، ونحن نحتفظ بالحق في تعطيل الوصول إلى أي محتوى لم نتلق منه الدفع الكافي.`,
      },
      {
        title: "3.3 المبالغ المستردة وائتمانات الاسترداد",
        subtitle: ` إذا لم يكن المحتوى الذي اشتريته هو ما كنت تتوقعه؛ فيمكنك أن تطلب في غضون 30 يوماً من شرائك للمحتوى، أن تقوم تدرب بتطبيق استرداد لحسابك، ولا ينطبق خيار الاسترداد هذا على مشتريات خطط الاشتراك.
 
نحتفظ بالحق في تطبيق استرداد أموالك كرصيد مسترد أو استرداد لطريقة الدفع الأصلية، وفقاً لتقديرنا، اعتماداً على قدرات مزودي خدمة الدفع لدينا، والنظام الأساسي الذي اشتريت منه المحتوى الخاص بك  - الموقع الإلكتروني أو تطبيق الهاتف الجوال -.
 
لا يوجد رد مستحق لك إذا طلبت ذلك بعد انقضاء مهلة الضمان البالغة 30 يوماً، ومع ذلك، إذا تم تعطيل المحتوى الذي اشتريته سابقاً لأسباب قانونية أو متعلقة بالسياسة؛ فيحق لك استرداد الأموال بعد هذا الحد البالغ 30 يوماً.
 
إذا قررنا إصدار أرصدة مستردة لحسابك؛ فسيتم تطبيقها تلقائياً في عملية شراء المحتوى التالية على موقعنا على الإنترنت، ولكن لا يمكن استخدامها في عمليات الشراء في تطبيقات الهاتف الجوال، وقد تنتهي صلاحية أرصدة الاسترداد إذا لم يتم استخدامها خلال الفترة المحددة وليس لها قيمة نقدية، في كل حالة ما لم يقضي القانون المعمول به خلاف ذلك.
 
وفقًا لتقديرنا؛ إذا اعتقدنا أنك تُسيء استخدام سياسة الاسترداد الخاصة بنا، مثل إذا كنت قد استهلكت جزءً كبيراً من المحتوى الذي تريد استرداده أو إذا قمت برد المحتوى مسبقاً؛ فإننا نحتفظ بالحق في رفض استرداد أموالك، وتقييدك من عمليات استرداد الأموال الأخرى في المستقبل، وحظر حسابك و / أو تقييد جميع الاستخدامات المستقبلية للخدمات.
 
إذا قمنا بحظر حسابك أو تعطيل وصولك إلى المحتوى بسبب انتهاكك لهذه الشروط أو إرشادات الثقة والأمان الخاصة بنا؛ فلن تكون مؤهلاً لاسترداد الأموال.`,
      },
      {
        title: "3.4 رموز الخصومات والترويج",
        subtitle: `قد تُقدم تدرب أو شركاؤها من المدربين هدايا ورموز ترويجية للطلاب، وقد يتم استرداد رموز معينة للحصول على هدايا أو ائتمانات ترويجية مطبقة على حساب تدرب الخاص بك، والتي يمكن استخدامها بعد ذلك لشراء محتوى مؤهل على نظامنا الأساسي، وفقاً للشروط المُتضمَنة في الرموز الخاصة بك، وقد تكون الرموز الأخرى قابلة للاسترداد مباشرة لمحتوى معين، لا يمكن استخدام الهدايا أو الائتمانات الترويجية للمشتريات في تطبيقات الهاتف الجوال.
 
قد تنتهي صلاحية هذه الرموز والائتمانات، بالإضافة إلى أي قيمة ترويجية مرتبطة بها؛ إذا لم يتم استخدامها خلال الفترة المحددة في حساب تدرب الخاص بك.
 
لا يجوز رد الهدايا أو الائتمانات الترويجية التي تقدمها تدرب نقداً، ما لم ينص على خلاف ذلك في الشروط المضمنة في رموزك أو وفقاً لما يقتضيه القانون المعمول به.
 
تخضع الهدايا أو الائتمانات الترويجية التي يقدمها الشريك لسياسات الاسترداد الخاصة بهذا الشريك، وذا كان لديك العديد من مبالغ الائتمان المحفوظة؛ فقد تحدد تدرب أي من الهدايا أو الائتمانات الترويجية، تنطبق على عملية الشراء الخاصة بك.
 
تحقق من صفحة الدعم الخاصة بنا وأي شروط مضمنة في رموزك لمزيد من التفاصيل.`,
      },
    ],
  },
  {
    type: "titleSubtitle",
    id: "قواعد المحتوى والسلوك",
    title: "4 - قواعد المحتوى والسلوك",
    subtitle: `يمكنك فقط استخدام تدرب لأغراض قانونية، وتكون بموجب ذلك مسؤولاً عن كل المحتوى الذي تنشره على منصتنا.
 
يجب عليك الاحتفاظ بالمراجعات والأسئلة والمنشورات والدورات التدريبية والمحتويات الأخرى التي تُحمّلها بما يتماشى مع إرشادات الثقة والأمان والقانون، واحترام حقوق الملكية الفكرية للآخرين.
 
يمكننا حظر حسابك بسبب المخالفات المتكررة أو الكبرى، وإذا كنت تعتقد أن شخصاً ما ينتهك حقوق الطبع والنشر الخاصة بك على نظامنا الأساسي؛ فأخبرنا بذلك.
 
لا يجوز لك الوصول إلى الخدمات أو استخدامها أو إنشاء حساب لأغراض غير قانونية، ويجب أن يتوافق استخدامك للخدمات والسلوك على منصتنا مع القوانين أو اللوائح المحلية أو الوطنية المعمول بها في بلدك، وتكون أنت وحدك المسؤول عن المعرفة والامتثال لهذه القوانين واللوائح التي تنطبق عليك.
 
إذا كنت طالباً؛ تُمكّنك الخدمات من طرح الأسئلة على مُدربي الدورات التدريبية أو المحتوى الآخر الذي قمت بالتسجيل فيه، ونشر مراجعات للمحتوى، وبالنسبة لمحتوى معين؛ قد يدعوك المدرب لإرسال محتوى كواجب منزلي أو اختبارات؛ فلا تنشر أو ترسل أي شيء ليس لك.
 
إذا كنت مدرباً؛ فيمكنك إرسال محتوى للنشر على النظام الأساسي ويمكنك أيضاً التواصل مع الطلاب الذين سجلوا في الدورات التدريبية الخاصة بك أو أي محتوى آخر، وفي كلتا الحالتين؛ يجب عليك الالتزام بالقانون واحترام حقوق الآخرين؛ فلا يمكنك نشر أي دورة تدريبية أو سؤال أو إجابة أو مراجعة أو أي محتوى آخر ينتهك القوانين أو اللوائح المحلية أو الوطنية المعمول بها في بلدك، وأنت وحدك المسؤول عن أي دورات ومحتوى وإجراءات تنشرها أو تتخذها عبر النظام الأساسي والخدمات وعواقبها.
 
تأكد من فهمك لجميع قيود حقوق النشر المنصوص عليها في شروط المدرب قبل إرسال أي محتوى للنشر على تدرب.
 
إذا تم إخطارنا بأن الدورة التدريبية أو المحتوى الخاص بك ينتهك القانون أو حقوق الآخرين؛ على سبيل المثال؛ إذا ثبت أنه ينتهك حقوق الملكية الفكرية أو حقوق الصور للآخرين، أو يتعلق بنشاط غير قانوني، وإذا اكتشفنا أن المحتوى أو السلوك الخاص بك ينتهك إرشادات الثقة والأمان الخاصة بنا، أو إذا كنا نعتقد أن المحتوى أو السلوك الخاص بك غير قانوني أو غير ملائم أو مرفوض، - على سبيل المثال إذا انتحلت شخصية شخص آخر -؛ فقد نزيل المحتوى الخاص بك من نظامنا الأساسي على منصة تدرب لأنه لا يتوافق مع قوانين حقوق النشر.
 
تحقق من سياسة الملكية الفكرية الخاصة بنا للحصول على مزيد من التفاصيل.
 
لدى تدرب السلطة التقديرية في تنفيذ هذه الشروط وإرشادات الثقة والأمان الخاصة بنا، ويجوز لنا تقييد أو إنهاء الإذن الممنوح لك لاستخدام منصتنا وخدماتنا أو حظر حسابك في أي وقت - مع أو بدون إشعار - لأي سبب أو بدون سبب، بما في ذلك أي انتهاك لهذه الشروط.
 
إذا فشلت في دفع أي رسوم عند استحقاقها، لطلبات رد المبالغ المدفوعة الاحتيالية، بناءً على طلب تطبيق القانون أو الوكالات الحكومية، لفترات طويلة من عدم النشاط، أو لمشاكل أو مشاكل فنية غير متوقعة، وإذا اشتبهنا في أنك تشارك في أنشطة احتيالية أو غير قانونية، أو لأي سبب آخر وفقاً لتقديرنا الخاص.
 
عند أي إنهاء من هذا القبيل؛ قد نحذف حسابك والمحتوى الخاص بك، وقد نمنعك من الوصول إلى الأنظمة الأساسية واستخدام خدماتنا.
 
قد يظل المحتوى الخاص بك متاحاً على الأنظمة الأساسية حتى إذا تم إنهاء حسابك أو تعليقه.
 
إذا نشر مستخدم محتوى ينتهك حقوق الطبع والنشر أو حقوق العلامة التجارية الخاصة بك؛ فيرجى إخبارنا بذلك.
 
لدينا شروط خاصة بالمدربين مطلوبة من مدربينا لمتابعة القانون واحترام حقوق الملكية الفكرية للآخرين.
 
لمزيد من التفاصيل حول كيفية رفع دعوى انتهاك حقوق النشر أو العلامة التجارية معنا، راجع سياسة الملكية الفكرية الخاصة بنا.`,
  },
  {
    type: "titleSubtitle",
    id: "حقوق تدرب في المحتوى الذي تنشره",
    title: "5 - حقوق تدرب في المحتوى الذي تنشره",
    subtitle: `أنت تحتفظ بملكية المحتوى الذي تنشره على منصة تدرب، بما في ذلك الدورات التدريبية الخاصة بك، ويُسمح لنا بمشاركة المحتوى الخاص بك مع أي شخص من خلال أي وسائط، بما في ذلك الترويج له عبر الإعلان على مواقع الإنترنت الأخرى.
 
يظل المحتوى الذي تنشره كطالب أو مدرب - بما في ذلك الدورات التدريبية – ملكاً لك، ومن خلال نشر الدورات التدريبية والمحتويات الأخرى؛ فإنك تسمح لتدرب بإعادة استخدامه ومشاركته ولكنك لا تفقد أي حقوق ملكية قد تكون لديك على المحتوى الخاص بك.
 
إذا كنت مدرباً؛ فتأكد من فهم شروط ترخيص المحتوى الموضحة بالتفصيل في شروط المدرب.
 
عندما تنشر محتوى وتعليقات وأسئلة ومراجعات، وعندما ترسل إلينا أفكاراً واقتراحات لميزات أو تحسينات جديدة؛ فإنك تفوض تدرب لاستخدام هذا المحتوى ومشاركته مع أي شخص، وتوزيعه والترويج له على أي نظام أساسي وفي أي وسائط، وإجراء أي تعديلات عليها بالشكل الذي نراه مناسباً.
 
في اللغة القانونية - من خلال إرسال المحتوى أو نشره على المنصات أو من خلالها -؛ فإنك تمنحنا ترخيصاً عالمياً غير حصري وخالٍ من حقوق الملكية - مع الحق في الترخيص من الباطن - لاستخدام ونسخ وإعادة إنتاج ومعالجة وتكييف وتعديل ونشر ونقل وعرض وتوزيع المحتوى الخاص بك - بما في ذلك اسمك وصورتك - في جميع الوسائط أو طرق التوزيع - الموجودة حاليًا أو التي تم تطويرها لاحقاً -، ويتضمن ذلك إتاحة المحتوى الخاص بك لشركات أو مؤسسات أو أفراد آخرين شركاء مع تدرب من أجل مشاركة المحتوى أو بثه أو توزيعه أو نشره على وسائط أخرى، وكذلك استخدام المحتوى الخاص بك لأغراض التسويق.
 
كما إنك تتنازل عن أي حقوق خصوصية أو دعاية أو حقوق أخرى ذات طبيعة مماثلة تنطبق على جميع هذه الاستخدامات، إلى الحد المسموح به بموجب القانون المعمول به.
 
أنت تقر وتتعهد بأن لديك جميع الحقوق والصلاحيات والسلطات اللازمة للسماح لنا باستخدام أي محتوى ترسله، كما أنك توافق أيضاً على جميع هذه الاستخدامات للمحتوى الخاص بك دون دفع أي تعويض لك.`,
  },
  {
    type: "titleSubtitle",
    id: "استخدام تدرب على مسؤوليتك الخاصة",
    title: "6 - استخدام تدرب على مسؤوليتك الخاصة",
    subtitle: `يمكن لأي شخص استخدام تدرب لإنشاء ونشر المحتوى والمدربين، ونحن نُمكّن المدربين والطلاب من التفاعل من أجل التدريس والتعلم؛ مثل الأنظمة الأساسية الأخرى حيث يمكن للأشخاص نشر المحتوى والتفاعل.
 
يعني نموذج النظام الأساسي لدينا أننا لا نراجع المحتوى أو نحرره لأسباب قانونية، ولسنا في وضع يسمح لنا بتحديد شرعية المحتوى، نحن لا نمارس أي سيطرة تحريرية على المحتوى المتاح على المنصة، وعلى هذا النحو، لا نضمن بأي شكل من الأشكال موثوقية المحتوى أو صحته أو دقته أو مصداقيته؛ فإذا قمت بالوصول إلى المحتوى؛ فإنك تعتمد على أي معلومات يقدمها المدرب على مسؤوليتك الخاصة.
 
باستخدام الخدمات؛ قد تتعرض لمحتوى تعتبره مسيئاً أو غير لائق أو مرفوضاً، لا تتحمل تدرب أي مسؤولية للحفاظ على هذا المحتوى منك ولا تتحمل أي مسؤولية عن وصولك أو تسجيلك في أي دورة تدريبية أو محتوى آخر، إلى الحد المسموح به بموجب القانون المعمول به، وينطبق هذا أيضاً على أي محتوى يتعلق بالصحة والعافية والتمارين البدنية.
 
أنت تُقر بالمخاطر الكامنة في الطبيعة الشاقة لهذه الأنواع من المحتوى، ومن خلال الوصول إلى هذا المحتوى؛ فإنك تختار تحمل تلك المخاطر طواعية، بما في ذلك مخاطر المرض أو الإصابة الجسدية أو الإعاقة أو الوفاة.
 
أنت تتحمل المسؤولية الكاملة عن الاختيارات التي تقوم بها قبل وأثناء وبعد وصولك إلى المحتوى.
 
عندما تتفاعل مباشرة مع طالب أو مدرب؛ يجب أن تكون حريصاً بشأن أنواع المعلومات الشخصية التي تشاركها.
 
بينما نقوم بتقييد أنواع المعلومات التي قد يطلبها المدربون من الطلاب؛ فإننا لا نتحكم فيما يفعلونه بالمعلومات التي يحصلون عليها من المستخدمين الآخرين على النظام الأساسي.
 
يجب ألا تشارك بريدك الإلكتروني أو أي معلومات شخصية أخرى عنك من أجل سلامتك.
 
نحن لا نوظف مدربين ولسنا مسؤولين عن أي تفاعلات بين المدربين والطلاب، ونحن لسنا مسؤولين عن النزاعات أو المطالبات أو الخسائر أو الإصابات أو الأضرار من أي نوع، والتي قد تنشأ عن، أو تتعلق بسلوك المدربين أو الطلاب.
 
عندما تستخدم خدماتنا؛ ستجد روابط لمواقع أخرى لا نملكها ولا نتحكم فيها؛ نحن لسنا مسؤولين عن المحتوى أو أي جانب آخر من مواقع الأطراف الثالثة هذه، بما في ذلك جمعهم للمعلومات عنك؛ مما يوجب عليك في هذه الحالة قراءة الشروط والأحكام وسياسات الخصوصية الخاصة بهم.`,
  },
  {
    type: "titleSubtitle",
    id: "حقوق تدرب",
    title: "7 - حقوق تدرب",
    subtitle: `نحن نمتلك نظام تدرب الأساسي والخدمات، بما في ذلك الموقع الإلكتروني والتطبيقات والخدمات الحالية أو المستقبلية وأشياء مثل شعاراتنا وواجهة برمجة التطبيقات (API) والرمز والمحتوى الذي أنشأه موظفونا، والتي لا يمكنك العبث بها أو استخدامها بدون إذن.
 
جميع الحقوق والملكية والمصالح في منصة تدرب وخدماتها والتي موقعنا على الإنترنت وتطبيقاتنا الحالية أو المستقبلية وواجهات برمجة التطبيقات وقواعد البيانات والمحتوى الذي يقدمه موظفونا أو شركاؤنا أو يقدمونه من خلال خدماتنا - باستثناء المحتوى المقدم من قبل المدربين والطلاب -، ستظل ملكية حصرية لتدرب والمرخصين التابعين لها.
 
منصاتنا وخدماتنا محمية بموجب حقوق النشر والعلامات التجارية والقوانين الأخرى لكل من دولة الكويت ودول الخليج.
 
لا شيء يمنحك الحق في استخدام اسم تدرب أو أي من العلامات التجارية والشعارات وأسماء المجال وميزات العلامة التجارية المميزة الأخرى لتدرب.
 
أي ملاحظات أو تعليقات أو اقتراحات قد تقدمها بخصوص تدرب أو الخدمات، تطوعية تماماً وسنكون أحراراً في استخدامها.
 
لا يجوز لك القيام بأي مما يلي أثناء الوصول إلى منصة وخدمات تدرب أو استخدامها: -
 
* الوصول إلى المناطق غير العامة من النظام الأساسي أو العبث بها أو استخدامها - بما في ذلك تخزين المحتوى - أو النظام الإلكتروني للمنصة أو أنظمة التسليم التقنية لموفري خدماتها.
 
* تعطيل أو التدخل في، أو محاولة التحايل على أي من ميزات الأنظمة الأساسية المتعلقة بالأمان أو فحص أو اختبار نقاط الضعف في أي من أنظمتنا.
 
* نسخ أو تعديل أو إنشاء عمل مشتق من، أو هندسة عكسية أو تجميع عكسي أو محاولة اكتشاف أي شفرة مصدر أو محتوى على منصة أو خدمات تدرب.
 
* الوصول إلى منصتنا أو البحث عنها أو محاولة الوصول إليها أو البحث عنها بأي وسيلة - إلكترونية أو غير ذلك - من خلال وظائف البحث المتوفرة حالياً لدينا، والتي يتم توفيرها عبر موقعنا الإلكتروني أو تطبيقات الهاتف الجوال أو واجهة برمجة التطبيقات، ووفقاً لشروط وأحكام واجهة برمجة التطبيقات، ولا يجوز لك كشط أو استخدام شفرة أو أي وسائل آلية أو إلكترونية أخرى من أي نوع للوصول إلى الخدمات.
 
* استخدام الخدمات بأي شكل من الأشكال لإرسال معلومات تعريف المصدر معدلة أو خادعة أو خاطئة مثل إرسال رسائل بريد إلكتروني تظهر بشكل خاطئ، أو التدخل في أو تعطيل أو محاولة القيام بذلك، ووصول أي مستخدم أو مضيف أو شبكة، بما في ذلك - على سبيل المثال لا الحصر -؛ إرسال فيروس أو التحميل الزائد أو الإغراق أو البريد العشوائي أو قصف المنصات أو الخدمات بالبريد، أو بأي طريقة أخرى تتدخل في الخدمات أو تنشئ عبئاً لا داعي له.`,
  },
  {
    type: "sectionNumbered",
    id: "شروط نظم الاشتراكات",
    title: "8 - شروط الاشتراك",
    subtitle: `يُغطي هذا القسم الشروط الإضافية التي تنطبق على استخدامك للمجموعات القائمة على الاشتراك كمتلعم "خطط الاشتراك".
 
باستخدام خطة الاشتراك؛ فإنك توافق على الشروط الإضافية الواردة في هذا القسم.`,
    subSections: [
      {
        title: "8.1 خطط الاشتراك",
        subtitle: `أثناء اشتراكك في خطة الاشتراك؛ تحصل على ترخيص محدود وغير حصري وغير قابل للتحويل منا للوصول إلى المحتوى المتضمن في خطة الاشتراك هذه وعرضه عبر الخدمات، باستثناء منح ترخيص الوصول مدى الحياة؛ تنطبق الشروط المضمنة في قسم "تسجيل المحتوى والوصول مدى الحياة" أعلاه على عمليات التسجيل عبر خطط الاشتراك.
 
يحدد الاشتراك الذي تشتريه أو تجدده نطاق وميزات وسعر وصولك إلى خطة الاشتراك، ولا يجوز لك نقل اشتراكك أو تعيينه أو مشاركته مع أي شخص آخر.
وجب التنوية انه قد يتم خصم ما يعادل ١ دولار في بعض البنوك خلال فترة التجربة المجانية وذلك اجراء أعتيادي من مقدمى خدمات الدفع للتأكد من صلاحية البطاقة المستخدمة فقط لا غير.
نحتفظ بالحق في إلغاء أي ترخيص لاستخدام المحتوى في خطط الاشتراك الخاصة بنا لأسباب قانونية أو متعلقة بالسياسة في أي وقت ووفقاً لتقديرنا الخاص؛ على سبيل المثال؛ إذا لم يعد لدينا الحق في عرض المحتوى من خلال خطة اشتراك.

بمجرد الاشتراك في تدرب بلا حدود تستطيع مشاهدة 99% من الدورات المتاحة على المنصة ما عدا بعض الدورات التي يكون لها رسوم إضافية بناءً عن رغبة المدربين

يتم تضمين معلومات إضافية حول حقنا في الإلغاء في قسم "تسجيل المحتوى والوصول مدى الحياة".`,
      },
      {
        title: "8.2 إدارة الحساب",
        subtitle: `يُمكنك إلغاء اشتراكك باتباع الخطوات الموضحة في صفحة الدعم الخاصة بنا.
 
إذا قمت بإلغاء اشتراكك في خطة الاشتراك؛ فسوف ينتهي وصولك إلى خطة الاشتراك هذه تلقائياً في اليوم الأخير من فترة الفوترة، وعند الإلغاء، لن يحق لك استرداد أو ائتمان أي رسوم تم دفعها بالفعل مقابل اشتراكك، ما لم يقتضي القانون المعمول به خلاف ذلك.
 
للتوضيح؛ لا يؤدي إلغاء الاشتراك إلى إنهاء حساب تدرب الخاص بك`,
      },
      {
        title: "8.3 الإصدارات التجريبية والتجديدات المجانية",
        subtitle: `قد يبدأ اشتراكك بتجربة مجانية، سيتم تحديد مدة الفترة التجريبية المجانية لاشتراكك أثناء التسجيل.
 
تحدد تدرب أهلية الإصدار التجريبي المجاني وفقاً لتقديرنا الخاص وقد يحد من الأهلية أو المدة، ونحتفظ بالحق كذلك في إنهاء الإصدار التجريبي المجاني وتعليق اشتراكك إذا قررنا أنك غير مؤهل.
 
سنقوم بتحصيل رسوم الاشتراك لدورة الفوترة التالية في نهاية الفترة التجريبية المجانية، وسيتم تجديد اشتراكك تلقائياً وفقاً لإعدادات اشتراكك؛ على سبيل المثال؛ شهرياً أو سنوياً، ما لم تقم بإلغاء اشتراكك قبل نهاية الفترة التجريبية المجانية.
 
لمزيد من المعلومات حول كيفية عرض الرسوم المطبقة وتواريخ الفترة التجريبية المجانية؛ قم بزيارة صفحة الدعم الخاصة بنا.`,
      },
      {
        title: "8.4 المدفوعات والفواتير",
        subtitle: `سيتم إدراج رسوم الاشتراك في وقت الشراء، ويمكنك زيارة صفحة الدعم الخاصة بنا لمعرفة المزيد حول مكان العثور على الرسوم والتواريخ المطبقة على اشتراكك.
 
قد يُطلب منا أيضاً إضافة ضرائب إلى رسوم اشتراكك كما هو موضح في قسم "المدفوعات والائتمانات والمبالغ المستردة" أعلاه.
 
المدفوعات غير قابلة للاسترداد ولا توجد مبالغ مستردة أو ائتمانات لفترات مستخدمة جزئياً، ما لم يقتضي القانون المعمول به خلاف ذلك، وبناءً على مكان وجودك؛ قد تكون مؤهلاً لاسترداد الأموال.
 
راجع سياسة رد الأموال الخاصة بخطط الاشتراك للحصول على معلومات إضافية.
 
للاشتراك في خطة الاشتراك؛ يجب عليك تقديم طريقة دفع.
 
من خلال الاشتراك في خطة الاشتراك وتقديم معلومات الفواتير الخاصة بك أثناء الخروج؛ فإنك تمنحنا ومقدمي خدمة الدفع لدينا، الحق في معالجة الدفع للرسوم المطبقة في ذلك الوقت عبر طريقة الدفع المسجلة لدينا، وفي نهاية كل فترة اشتراك، سنقوم تلقائياً بتجديد اشتراكك لنفس المدة ومعالجة طريقة الدفع الخاصة بك لدفع الرسوم المطبقة في ذلك الوقت.
 
في حالة قيامنا بتحديث طريقة الدفع الخاصة بك باستخدام المعلومات المقدمة من مزودي خدمة الدفع لدينا - كما هو موضح في قسم "المدفوعات والائتمانات والمبالغ المستردة" أعلاه؛ فإنك تفوضنا لمواصلة تحصيل الرسوم المطبقة في ذلك الوقت على طريقة الدفع المُحدَثَة.
 
إذا لم نتمكن من معالجة الدفع من خلال طريقة الدفع المسجلة لدينا، أو إذا قدمت طلباً لرد المبالغ المدفوعة يعترض على الرسوم المفروضة على طريقة الدفع الخاصة بك وتم منح رد المبالغ المدفوعة؛ فيجوز لنا تعليق اشتراكك أو إنهائه.
 
نحتفظ بالحق في تغيير خطط الاشتراك الخاصة بنا أو تعديل أسعار خدماتنا وفقاً لتقديرنا الخاص.
 
تسري أي تغييرات في الأسعار على اشتراكك بعد إخطارك، باستثناء ما يقتضيه القانون المعمول به.`,
      },
      {
        title: "8.5 إخلاء مسؤولية الاشتراك",
        subtitle: `نحن لا نقدم أي ضمانات فيما يتعلق بتوفر أي محتوى محدد أو أي قدر أدنى من المحتوى في أي خطة اشتراك، في أي وقت في المستقبل، ونحتفظ بالحق في عرض ميزات إضافية أو التوقف عن تقديمها لأي خطة اشتراك، أو تعديل خطة الاشتراك أو إنهائها وفقاً لتقديرنا الخاص، وتُضاف إخلاء المسؤولية هذه إلى تلك المُدرجة في قسم "إخلاء المسؤولية" أدناه.`,
      },
    ],
  },
  {
    type: "sectionNumbered",
    id: "شروط قانونية متنوعة",
    title: "9 - شروط قانونية متنوعة",
    subtitle:
      "تشبه هذه الشروط أي عقد آخر، ولديها شروط قانونية مملة ولكنها مُهمة، تحمينا من الأشياء التي لا حصر لها والتي يمكن أن تحدث والتي توضح العلاقة القانونية بيننا وبينك.",
    subSections: [
      {
        title: "9.1 اتفاقية ملزمة",
        subtitle: `أنت توافق على أنه من خلال التسجيل أو الوصول إلى خدماتنا أو استخدامها؛ على الدخول في عقد ملزم قانونًا مع تدرب إذا كنت لا توافق على هذه الشروط؛ فلا تقم بالتسجيل أو الوصول إلى أو استخدام أي من خدماتنا بأي طريقة أخرى.
 
إذا كنت مدرباً يقبل هذه الشروط وتستخدم خدماتنا نيابة عن شركة أو مؤسسة أو حكومة أو كيان قانوني آخر؛ فأنت تقر وتضمن أنك مخول للقيام بذلك.
 
هذه الشروط مُتضمنة أي اتفاقات وسياسات مرتبطة؛ تُشكل مجمل الاتفاق بينك وبيننا والتي تشمل، - إذا كنت مدرباً - شروط المدربين وسياسة الترقيات. 
 
إذا تبين أن أي جزء من هذه الشروط غير صالح أو غير قابل للتنفيذ بموجب القانون المعمول به؛ فسيتم اعتبار هذا الحكم مستبدلاً بحكم صالح وقابل للتنفيذ يتطابق إلى حد كبير مع الغرض من الحكم الأصلي وستظل بقية هذه الشروط سارية المفعول.
 
حتى إذا تأخرنا في ممارسة حقوقنا أو فشلنا في ممارسة حق في حالة واحدة؛ فهذا لا يعني أننا نتنازل عن حقوقنا بموجب هذه الشروط، وقد نقرر تنفيذها في المستقبل، وإذا قررنا التنازل عن أي من حقوقنا في حالة معينة؛ فهذا لا يعني أننا نتنازل عن حقوقنا بشكل عام أو في المستقبل.

 
يجب أن تظل الأقسام التالية سارية بعد انتهاء أو إنهاء هذه الشروط: -
 
        * 2 تسجيل المحتوى والوصول مدى الحياة.
 
        * 5 حقوق تدرب للمحتوى الذي تنشره. 
 
        * 6 استخدام تدرب على مسؤوليتك الخاصة.
 
        * 7 حقوق تدرب. 
 
        * 8.5 إخلاء مسؤولية الاشتراك.
 
        * 9 شروط قانونية متنوعة. 
 
        * 10 تسوية المنازعات.
`,
      },
      {
        title: "9.2 إخلاء المسؤولية",
        subtitle: `قد يحدث أن تكون منصتنا مُعطلة، إما بسبب الصيانة المخطط لها أو بسبب حدوث شيء ما مع الموقع، وقد يحدث أن يُدلي أحد مدربينا ببيانات مضللة في محتواهم، وقد يحدث أيضاً أن نواجه مشكلات أمنية، وهذه مجرد أمثلة، لكنك بموجب ذلك تقبل أنه لن يكون لديك أي سبيل للطعن ضدنا في أي من هذه الأنواع من الحالات التي لا تسير فيها الأمور بشكل صحيح، وفي لغة قانونية أكثر اكتمالاً، يتم توفير الخدمات ومحتواها "كما هي" و "حسب توفرها".
 
نحن والشركات التابعة لنا، والموردون، والشركاء، والوكلاء، لا نُقدم أي إقرارات أو ضمانات بشأن ملاءمة الخدمات أو محتواها أو موثوقيتها أو توفرها أو حسن توقيتها أو أمانها أو عدم وجود أخطاء أو دقة فيها، وننكر صراحة أي ضمانات أو شروط صريحة أو ضمنية، بما في ذلك الضمانات الضمنية الخاصة بالتسويق والملاءمة لغرض معين والملكية وعدم الانتهاك.
 
نحن والشركات التابعة لنا والموردون والشركاء والوكلاء، لا نُقدم أي ضمان بأنك ستحصل على نتائج محددة من استخدام الخدمات، وإن استخدامك للخدمات - بما في ذلك أي محتوى -، يكون على مسؤوليتك الخاصة بالكامل.
 
لا تسمح بعض الولايات القضائية باستثناء الضمانات الضمنية؛ لذلك قد لا تنطبق عليك بعض الاستثناءات المذكورة أعلاه.
 
قد نقرر التوقف عن إتاحة ميزات معينة للخدمات في أي وقت ولأي سبب، وهذا يعني أن منصة تدرب لن تتحمل أو الشركات التابعة لها أو مورديها أو شركائها أو وكلائها تحت أي ظرف من الظروف، المسؤولية عن أي أضرار ناجمة عن هذه الانقطاعات أو عدم توفر هذه الميزات.
 
نحن لسنا مسؤولين عن تأخير أو فشل أداء أي من الخدمات بسبب أحداث خارجة عن سيطرتنا، مثل العمل الحربي أو العداء أو التخريب أو كارثة طبيعية أو انقطاع الكهرباء أو الإنترنت أو الاتصالات أو القيود الحكومية.`,
      },
      {
        title: "9.3 تحديد المسؤولية",
        subtitle: `هناك مخاطر متأصلة في استخدام خدماتنا؛ على سبيل المثال؛ إذا قمت بالوصول إلى محتوى الصحة والعافية، وتسببت في أذية نفسك؛ فأنت تقبل تماماً هذه المخاطر وتوافق على أنه لن يكون لك حق اللجوء إلى المطالبة بتعويضات حتى إذا تعرضت لخسارة أو ضرر من استخدام منصتنا وخدماتنا.
 
في لغة قانونية أكثر اكتمالاً؛ إلى الحد الذي يسمح به القانون، لن نتحمل نحن وشركات مجموعتنا وموردينا وشركائنا ووكلائنا أي مسؤولية عن أي أضرار غير مباشرة أو عرضية أو تأديبية أو تبعية بما في ذلك فقدان البيانات أو الإيرادات أو الأرباح أو الفرص التجارية، أو الإصابة الشخصية أو الوفاة، سواء كانت ناتجة عن عقد أو ضمان أو ضرر أو مسؤولية المنتج أو غير ذلك، وحتى إذا تم إبلاغنا بإمكانية حدوث أضرار مقدماً.
 
تقتصر مسؤوليتنا ومسؤولية كل من شركات مجموعتنا وموردينا وشركائنا ووكلائنا تجاهك أو تجاه أي طرف ثالث تحت أي ظرف من الظروف، على ما يزيد عن مائة دولار (100 دولار) أو المبلغ الذي دفعته لنا في اثني عشر (12) شهراً قبل الحدث الذي أدى إلى ظهور مطالباتك`,
      },
      {
        title: "9.4 التعويض",
        subtitle: `إذا كنت تتصرف بطريقة تسبب لنا مشكلة قانونية؛ فقد نمارس حق الرجوع القانوني ضدك، وأنت توافق على تعويض والدفاع - إذا طلبنا ذلك -، وإبراء ذمة تدرب، وشركات مجموعتنا، ومسؤوليها ومديريها ومورديها وشركائها ووكلائها من أي مطالبات أو مطالب أو خسائر أو أضرار من طرف ثالث، والتي تتضمن؛ النفقات - بما في ذلك أتعاب المحاماة المعقولة - الناشئة عن (أ) المحتوى الذي تنشره أو ترسله ، (ب) استخدامك للخدمات (ج) انتهاكك لهذه الشروط ، أو (د) انتهاكك لأي حقوق لطرف ثالث، وسيظل التزامك بالتعويض سارياً بعد إنهاء هذه الشروط واستخدامك للخدمات.`,
      },
      {
        title: "9.5 القانون الحاكم والاختصاص القضائي",
        subtitle: `عندما تذكر تدرب هذه الشروط؛ فإنها تشير إلى كيان تدرب الذي تتعاقد معه، وإذا كنت طالباً؛ فسيتم تحديد الكيان المتعاقد والقانون الحاكم بشكل عام بناءً على موقعك.
 
في الحالات التي لا ينطبق عليك فيها قسم "حل النزاع" أدناه؛ فإنك توافق على الاختصاص القضائي الحصري ومكان المحاكم في دولة الكويت.`,
      },
      {
        title: "9.6 الإجراءات القانونية والإشعارات",
        subtitle: `لا يجوز لأي طرف رفع أي إجراء - بغض النظر عن الشكل - ينشأ عن أو يتعلق بهذه الاتفاقية من قبل أي من الطرفين بعد أكثر من عام واحد (1) بعد استحقاق سبب الدعوى، باستثناء الحالات التي لا يمكن فيها فرض هذا القيد بموجب القانون.
 
سيكون أي إشعار أو اتصال آخر يتم تقديمه أدناه كتابياً ويتم إرساله عن طريق إيصال إرجاع بالبريد المسجل أو المعتمد المطلوب، أو عبر البريد الإلكتروني من خلالنا إلى البريد الإلكتروني المرتبط بحسابك أو بواسطتك إلى ( info@tadarab.com )`,
      },
      {
        title: "9.7 العلاقة بيننا",
        subtitle:
          "نحن وأنت نتفق على عدم وجود مشروع مشترك أو شراكة أو توظيف أو مقاول أو وكالة بيننا.",
      },
      {
        title: "9.8 عدم التنازل",
        subtitle: `لا يجوز لك التنازل عن هذه الشروط أو نقلها أو الحقوق والتراخيص الممنوحة بموجبها؛ فعلى سبيل المثال؛ إذا قمت بتسجيل حساب كموظف في شركة؛ فلا يمكن نقل حسابك إلى موظف آخر.
 
يجوز لنا التنازل عن هذه الشروط أو الحقوق والتراخيص الممنوحة بموجبها لشركة أو شخص آخر دون قيود، ولا يوجد في هذه الشروط ما يمنح أي حق أو منفعة أو تعويض لأي شخص أو كيان تابع لجهة خارجية.
 
أنت توافق على أن حسابك غير قابل للتحويل وأن جميع الحقوق في حسابك والحقوق الأخرى بموجب هذه الشروط تنتهي عند وفاتك.`,
      },
      {
        title: "9.9 قوانين العقوبات والتصدير",
        subtitle: `لا يجوز لك الوصول إلى أي جزء من الخدمات أو أي معلومات أو مواد تقنية ذات صلة أو استخدامه أو تصديره أو إعادة تصديره أو تحويله أو نقله أو الكشف عنه - بشكل مباشر أو غير مباشر - بما ينتهك أي عقوبات تجارية تفرضها دولة الكويت وغيرها من البلدان المعمول بها هذه القوانين والقواعد واللوائح.
 
أنت توافق على عدم تحميل أي محتوى أو تقنية - بما في ذلك معلومات حول التشفير - يتم التحكم في تصديرها بشكل خاص بموجب هذه القوانين.`,
      },
    ],
  },
  {
    type: "sectionNumbered",
    id: "تسوية المنازعات",
    title: "10 - تسوية المنازعات",
    subtitle: `في حالة وجود نزاع؛ يسعد فريق الدعم لدينا بالمساعدة في حل المشكلة، وإذا لم يفلح ذلك وكنت تعيش في دولة الكويت أو دول الخليج؛ فإن خياراتك هي الذهاب إلى محكمة الدعاوى الصغيرة أو رفع دعوى في التحكيم الملزم، ولا يجوز لك رفع هذه الدعوى في محكمة أخرى أو المشاركة في دعوى جماعية غير فردية ضدنا.
 
ينطبق قسم حل النزاعات هذا فقط إذا كنت تعيش في دولة الكويت أو دول الخليج، ويمكن حل معظم النزاعات؛ لذا قبل رفع دعوى قانونية رسمية؛ يرجى أولاً محاولة الاتصال بفريق الدعم لدينا.`,
    subSections: [
      {
        title: "10.1 المطالبات الصغيرة",
        subtitle:
          "يمكن لأي منا رفع دعوى في محكمة الدعاوى الصغيرة في (أ) دولة الكويت (ب) البلد التي تعيش فيها، أو (ج) مكان آخر نتفق عليه معاً، طالما كنا مؤهلَيْن لتقديمه إلى تلك المحكمة.",
      },
      {
        title: "10.2 الذهاب إلى التحكيم",
        subtitle: `إذا لم نتمكن من حل نزاعنا ودياً؛ فأنت توافق وتدرب على حل أي مطالبات تتعلق بهذه الشروط - أو شروطنا القانونية الأخرى - من خلال التحكيم النهائي والملزم، بغض النظر عن نوع المطالبة أو النظرية القانونية.
 
إذا رفع أحدنا دعوى في المحكمة يجب التحكيم فيها ورفض الطرف الآخر التحكيم فيها؛ فيمكن للطرف الآخر أن يطلب من المحكمة إجبارنا على الذهاب إلى التحكيم (إلزام التحكيم).
 
يمكن لأي منا أيضًا أن يطلب من المحكمة وقف إجراءات المحكمة أثناء إجراء التحكيم.
`,
      },
      {
        title: "10.3 عملية التحكيم",
        subtitle: `يجب حل أي نزاعات تنطوي على مطالبة تقل قيمتها عن 10000 دولار أمريكي حصرياً من خلال التحكيم الملزم الذي لا يستند إلى المثول.
 
يجب على الطرف الذي يختار التحكيم بدء الإجراءات عن طريق تقديم طلب التحكيم إلى جمعية التحكيم الكويتية.
 
تخضع إجراءات التحكيم لقواعد التحكيم التجاري لجمعية التحكيم الكويتية، وبروتوكول الإجراءات القانونية للمستهلكين، والإجراءات التكميلية لتسوية المنازعات المتعلقة بالمستهلكين.
 
أنت ونحن نتفق على أن القواعد التالية ستنطبق على الإجراءات: -
 
(أ) سيتم إجراء التحكيم عبر الهاتف أو عبر الإنترنت أو بناءً على التقارير المكتوبة فقط - بناءً على اختيار الطرف الذي يسعى للحصول على الإغاثة –
 
(ب) يجب ألا يتضمن التحكيم أي ظهور شخصي من قبل الأطراف أو الشهود - ما لم نتفق نحن وأنت على خلاف ذلك –
 
(ج) يجوز إدخال أي حكم بشأن قرار التحكيم الصادر عن المحكم في أي محكمة ذات اختصاص قضائي، ويجب حل النزاعات التي تنطوي على مطالبة بأكثر من 10000 دولار أمريكي وفقاً لقواعد جمعية التحكيم الكويتية بشأن ما إذا كان يجب أن تكون جلسة التحكيم شخصية أم لا.`,
      },
      {
        title: "10.4 عدم وجود دعاوى جماعية",
        subtitle: `نتفق كلانا على أنه لا يمكننا رفع دعاوى ضد الآخر إلا على أساس فردي، وهذا يعني: -
 
(أ) لا يمكن لأي منا رفع دعوى كمدعي أو عضو جماعي في دعوى جماعية أو دعوى موحدة أو إجراء تمثيلي.
 
(ب) لا يمكن للمحكم الجمع بين مطالبات عدة أشخاص في قضية واحدة أو رئاسة أي إجراء موحد أو جماعي أو تمثيلي.
 
(ج) قرار أو حكم محكم في حالة شخص واحد يمكن أن يؤثر فقط على هذا المستخدم، وليس المستخدمين الآخرين، ولا يمكن استخدامه للبت في نزاعات المستخدمين الآخرين، وإذا قررت المحكمة أن بند "عدم وجود دعاوى جماعية" هذا غير قابل للتنفيذ أو صالح؛ فسيكون قسم "حل النزاعات" هذا لاغياً وباطلاً، ولكن ستظل بقية البنود سارية.`,
      },
      {
        title: "10.5 التغييرات",
        subtitle: `بصرف النظر عن قسم "تحديث هذه الشروط" أدناه؛ إذا قامت تدرب بتغيير قسم "حل النزاعات" هذا بعد آخر تاريخ أشرت فيه إلى قبول هذه الشروط؛ فيجوز لك رفض أي تغيير من خلال تقديم إشعار خطي من تدرب بهذا الرفض عن طريق البريد أو التسليم باليد إلى (مدينة الكويت . المرقاب ، سوق الوطنية مكتب ٤١٢) وعن طريق البريد الإلكتروني من عنوان البريد الإلكتروني المرتبط بحسابك إلى (info@tadarab.com)، في غضون 30 يوماً من تاريخ سريان هذا التغيير، كما هو موضح بواسطة لغة "آخر تحديث في" أعلاه.
 
ولكي يكون الإشعار ساريًا؛ يجب أن يتضمن اسمك بالكامل وأن يشير بوضوح إلى نيتك في رفض التغييرات التي تم إجراؤها على قسم "حل النزاع".`,
      },
    ],
  },
  {
    type: "titleSubtitle",
    id: "تحديث هذه الشروط",
    title: "11 - تحديث هذه الشروط",
    subtitle: `من وقت لآخر، قد نقوم بتحديث هذه الشروط لتوضيح ممارساتنا أو لعكس ممارسات جديدة أو مختلفة؛ مثل عند إضافتنا لميزات جديدة، وتحتفظ تدرب بالحق في تعديل و / أو إجراء تغييرات على هذه الشروط، وفقًا لتقديرها الخاص في أي وقت.
 
إذا قمنا بإجراء أي تغيير جوهري؛ فسنخطرك باستخدام وسائل بارزة، مثل إرسال إشعار بالبريد الإلكتروني إلى عنوان البريد الإلكتروني المحدد في حسابك أو عن طريق نشر إشعار من خلال خدماتنا، وستصبح التعديلات سارية المفعول في يوم نشرها ما لم يُنص على خلاف ذلك.
 
إن استمرارك في استخدام خدماتنا بعد أن تصبح التغييرات سارية المفعول يعني أنك تقبل هذه التغييرات، ويجب أن تحل أي شروط تمت مراجعتها محل جميع الشروط السابقة.`,
  },
  {
    type: "titleSubtitle",
    id: "كيفية الاتصال بنا",
    title: "12 - كيفية الاتصال بنا",
    subtitle: `أفضل طريقة للتواصل معنا هي الاتصال بفريق الدعم الخاص بنا، يسعدنا سماع أسئلتك ومخاوفك وتعليقاتك حول خدماتنا. (support@tadarab.com)
شكراً للتعلم معنا!`,
  },
  {
    type: "relatedList",
    title: "مقالات ذات صلة",
    items: [
      { id: 0, label: "سياسة ملفات تعريف الارتباط", value: "/cookies-policy" },
      { id: 1, label: " السياسات والخصوصية", value: "/privacy-policy" },
    ],
  },
];

export const instructorTermsAndConditions = [
  {
    type: "titleSubtitle",
    id: null,
    title: "تمهيد",
    subtitle: `تتشرف منصة تدرَّب الرائدة في مجال التدريب بدعوتك لتكون شريك نجاح في المنصة ووجب علينا ان نوضح ان هذه الشروط التي يعتبر بمثابة عقد شراكة بين منصة تدرَّب كطرف اول وبينك كمقدم محتوى كطرف ثاني  ويعتبر الطرفين بهذه الشروط شركاء في نشر محتواك التدريبي على المنصة.
وبصفتك (طرف ثاني ) فأنت تتعاقد مُباشرة مع منصة تدرَّب( طرف أول) التابعة لشركة فاست فورورد بدولة الكويت، بغض النظر إذا كانت هناك شركة تابعة أخرى لتدرَّب تُسهِّل لك عملية المدفوعات أم لا.
هذا العقد ملزم على كل المدربين ومقدمي المحتوى على منصة تدرب بدون استثناء كما وجب التوضيح ان هذا العقد غير قابل للتعديل او إضافة او حذف اب بند من بنودة واستخدامك للمنصة ونشر محتواك عليها يعتبر إقرار منك على الالتزام ببنود هذا العقد، والتي يمكن اعتبارها شروط عامة يختص بها  جميع المُدرِّبين مع منصة تدرَّب وهي عبارة عن شروط تحكم استخدامك للخدمات التي تُقدِّمها بالتعاون مع منصة تدرب.`,
  },
  {
    type: "titledList",
    title: "أحكام وبنود التعاون",
    items: instructorTermsAndConditionsListItems,
  },
  {
    type: "sectionNumbered",
    id: "التزامات المُدرِّب",
    title: "1 - التزامات المُدرِّب",
    subtitle: `المُدرِّب؛ مسؤول  مسؤولية تامة عن كل المحتوى المُقدم عبر منصة تدرَّب ، مُتضمِّناً المُحاضرات والاختبارات القصيرة وتمارين الترميز واختبارات المُمارسة والواجبات والموارد والإجابات ومحتوى صفحة الهبوط والمُختبرات والتقييمات والإعلانات (المحتوى المُقدَّم).`,
    subSections: [
      {
        title: "-:وعليه فأنك تُقِر بما يلي",
        subtitle: `(1.1.1) لتفويض تدرب  لاستخدام المحتوى المقدم كما هو محدد في هذه الشروط وشروط الاستخدام
 
(2.1.1) أن المحتوى المقدم الخاص بك لن ينتهك او يسي استخدام حقوق الملكية لاي طرف ثالث .
(3.1.1) انه لديك المؤهلات وبيانات الاعتماد والخبرة المطلوبة متضمنا التعليم والتدريب  والمهارات اللازمة لتدريب وتقديم الخدمات من خلال المحتوى الخاص بك واستخدامها .
(4.1.1) ستضمن جودة الخدمة التي تتوافق مع معايير الصناعة والخدمات التعليمية بشكل عام .`,
      },
      {
        title: "-:وتتعهد بما يلي",
        subtitle: ` عدم نشر او تقديم اي محتوى او معلومات غير لائقة او مسيئة او عنصرية او بغيضة او متحيزة جنسيا او إباحية
(1.2.1) او كاذبة او مضللة او غير صحيحة او منتهكة او تشهيرية مع الالتزام التام بقانون دولة الكويت في كل مايخص البنود السابقة ذكرها
(1.2.2) عدم استخدام الخدمات في غير الأعمال المحددة ، وهي تقديم خدمات التدريس والتعليم والخدمات التعليمية للطُلاب 
(1.2.3) عدم الانخراط في أي نشاط يتطلب من شركة تدرَّب الحصول على تراخيص من أي طرف ثالث أو دفع مُقابل ماديّ له، مُتضمناً الحاجة إلى دفع حقوق ملكية للأداء العام لعمل موسيقيّ أو تسجيل صوتيّ.
(1.2.4) عدم انتحال شخصية شخص آخر أو الحصول على تصريح دخول غير مُصرَّح به إلى حساب شخص آخر
(1.2.5)  هيكلة الخدمات أو تضمينها؛ مثل تضمين نسخة مجانية من الدورة التدريبية، أو التحايل على الخدمات`,
      },
    ],
  },
  {
    type: "sectionNumbered",
    id: "ترخيص تدرَّب",
    title: "2 - ترخيص تدرَّب",
    subtitle: `بموجَب هذا العقد فأنت تمنح شركة تدرَّب الحقوق المُفصَّلَة في شروط الاستخدام لعرض المحتوى المُقدَّم وتسويقه واستغدامه بأي طريقة أخرى تراها، والتي تتضمن؛ إضافة تسميات توضيحية أو تعديل المحتوى المُقدَّم بطريقة مُختلفة لضمان إمكانية الوصولكما إنك تُفوِّض تدرَّب بإعادة ترخيص هذه الحقوق للمحتوى المُقدَّم الخاص بك إلى أطراف ثالثة، والتي تتضمن تقديمها للطُلاب مباشرة، ومن خلال أطراف ثالثة مثل البائعين والموزعين والمواقع التابعة ومواقع الصفقات والإعلانات المدفوعة على منصات الطرف الثالث ما لم يتم الاتفاق على خلاف ذلك (بما فيها سياسة العروض الترويجية الخاصة بشركة تدرَّب)، يحق لك إزالة كل أو أي جزء من المحتوى المُقدَّم الخاص بك من الخدمات في أي وقت، باستثناء ما تم الاتفاق عليه بخلاف ذلك، وسينتهي حق تدرَّب في منح الحقوق الواردة في هذا القسم، فيما يتعلق بالمُستخدمين الجُدد بعد 60 يوماً من إزالة المحتوى المُقدَّم `,
    subSections: [
      {
        title: "-:وعلى أي حال؛ فإن",
        subtitle: `(1.1.2) الحقوق الممنوحة للمشتركين  الممتلكين لدوراتك في حال طلب إزالة المحتوى المُقدَّم من طرفك ستستمر وفقاً لشروط تلك التراخيص، بما في ذلك منح المحتوى للمشتركين مدى الحياة
        
 يجوز لشركة تدرَّب، تسجيل واستخدام كل أو أي جزء من المحتوى المُقدَّم الخاص بك لمُراقبة الجودة ولتقديم الخدمات أو تسويقها أو الترويج لها أو عرضها أو تشغيلها، وبموجب ذلك؛ فأنت تمنح تدرَّب إذناً لاستخدام اسمك وصوتك وصورك، فيما يتعلق بعرض الخدمات أو المحتوى المقدم أو محتوى تدرَّب الخاص بك، وتسليمها وتسويقها وترويجها وعرضها وبيعها، وتتنازل عن أي حقوق للخصوصية والدعاية أو غيرها من الحقوق  ذات الطبيعة المُماثلة، إلى الحد المسموح به بموجب القانون المعمول به `,
      },
    ],
  },
  {
    type: "sectionNumbered",
    id: "الثقة والأمان",
    title: "3 - الثقة والأمان",
    subSections: [
      {
        title: "( 1.3 سياسات الثقة والأمان)",
        subtitle: `المُدرِّب موافق على الالتزام بسياسات الثقة والأمان الخاصة بشركة تدرَّب، ومعايير أو سياسات جودة المحتوى الأخرى التي تُحددها تدرَّب من وقت لآخر، وعليه يجب مُراجعة هذه السياسات بشكل دوريّ للتأكد من الامتثال لأي تحديثات يتم إضافتها إليها، كما إنك تُدرِك أن استخدامك للخدمات، تخضع لموافقة تدرَّب، والتي قد تمنحها أو ترفضها وفقًا لتقديرها الخاص.

تحتفظ تدرَّب بالحق في إزالة المحتوى و / أو تعليق المدفوعات و / أو حظر المُدرِّبين لأي سبب في أي وقت، دون إشعار مُسبَق،`,
      },
      {
        title: "مُتضمنة الحالات التالية",
        subtitle: `(3.1.1) لا يلتزم المُدرِّب مقدم المحتوى او من ينوب عنه بسياسات شركة تدرَّب أو الشروط القانونية، ومن ضمنها شروط الاستخدام
(3.1.2) المحتوى إذا ثبت أنه أقل من معايير الجودة لدى تدرَّب أو له تأثير سلبيّ على تجربة الطالب
(3.1.3) ظهور المُدرِّب في سلوك قد ينعكس بشكل سلبيّ على تدرَّب أو يتسبب في تشويه سُمعتها أو الازدراء أو الفضيحة أو السُخرية
(3.1.4) يستخدم المُدرِّب الخدمات بطريقة تُشكِّل مُنافسة غير عادلة، مثل الترويج لأعماله خارج الموقع بطريقة تنتهك سياسات تدرَّب، أوعلى النحو الذي تحدده وفقًا لتقديرها الخاص
`,
      },
      {
        title: "(2.3  المُدربون المشتركين ومساعدو المدربين)",
        subtitle: `تُتيح منصة تدرَّب، إضافة مُستخدمين آخرين كمُدربين مُشاركين أو مُساعدي تدريب للمحتوى المُقدَّم الذي تُديره، وأنت مُطالَب بالامتثال لقواعد وإرشادات علاقة المُدرِّب المُساعد الخاصة بتدرَّب، عند اتخاذ مثل هذه الإجراءات.
من خلال إضافة مُدرِّب مُساعد أو مُساعد تدريس؛ فإنك تُدرِك أنك تفوضه باتخاذ إجراءات مُعينة تؤثر على حساب تدرَّب والمحتوى المُقدَّم، وقد تؤثر أيضاً انتهاكات شروط وسياسات تدرَّب من قِبَل مُدرِّبك المُشارِك أو مُساعد التدريب على حساب تدرَّب والمحتوى المُقدَّم.
 وعليه فإن منصة تدرَّب غير قادرة على تقديم المشورة بشأن أي أسئلة أو الوساطة في حل اى نزاعات بين المدرب وبين المُستخدمين، وإذا كان لدى زملائك المُدرِّبين نسبة إيرادات مُعينة فمسؤلية تلك الإيرادات تكون من خلالك كمدرب بنسبة 100٪ دون تدخل تدرب فيها باي شكل من الاشكال`,
      },
      {
        title: "(3.3 العلاقة بالمُستخدمين الآخرين )",
        subtitle: `ليس للمُدرِّبين علاقة تعاقُدية مُباشرة مع المشتركين؛ لذا فإن المعلومات الوحيدة التي ستتلقاها عن المشتركين هي ما يتم توفيره لك من خلال الخدمات، وبموجب ذلك فأنت توافق على أنك لن تستخدم البيانات التي تتلقاها لأي غرض بخلاف تقديم خدماتك لهؤلاء الطلاب على منصة تدرَّب، وإنك لن تطلب بيانات شخصية إضافية أو تُخزِّن البيانات الشخصية للمشتركين خارج منصة تدرَّب، كما توافق على تعويض تدرَّب ضد أي مُطالبَات تنشأ عن استخدامك للبيانات الشخصية المشتركين.`,
      },
    ],
  },
  {
    type: "sectionNumbered",
    id: "المدفوعات",
    title: "5 - المدفوعات",
    subSections: [
      {
        title: "(1.5 حصة الإيرادات )",
        subtitle: `عندما يمتلك المشترك المحتوى المُقدَّم الخاص بك؛ تقوم تدرَّب بحساب المبلغ الإجماليّ للبيع على أنه المبلغ الذي استلمته بالفعل من المشترك(المبلغ الإجماليّ)، ومن خلاله تقوم تدرَّب بطرح أي ضرائب على المُعاملات، وأي رسوم لمنصة الهاتف الجوَّال مُطبَّقَة على مبيعات الدفع لمزود خدمة الهاتف الجوَّال، ورسوم خدمات الدفع بنسبة 3.5.%، لأي مبيعات خارج الخدمة لمزود خدمات الهاتف الجوَّال، وأي مبالغ مدفوعة لأطراف ثالثة فيما يتعلق بالبرامج الترويجية لحساب صافي مبلغ البيع (المبلغ الصافي).

وإذا لم تقُم بالاشتراك في أي من برامج تدرَّب الترويجية الاختيارية، وباستثناء المبيعات من خلال رموز القسائم التي يُنشئها المُدرِّب، أو روابط إحالة الدورة التدريبية؛ فستكون حصة الإيرادات الخاصة بك 70% من صافي المبلغ منقوصاً منه أي خصومات قابلة للتطبيق، مثل المبالغ التي يستردُّها المشترك والحملات الترويجية و العمولة البنكية ، وإذا قامت تدرَّب بتغيير مُعدَّل الدفع هذا؛ فستُقدِّم لك إشعاراً لمدة 30 يوماً باستخدام وسائل بارزة، مثل رسائل البريد الإلكترونيّ أو عن طريق نشر إشعار عبر خدمات المنصة.

في حال الاشتراك في أي من البرامج الترويجية؛ فقد تختلف حصة الإيرادات ذات الصلة وستكون على النحو  التالي
`,
      },
      {
        title: "(5.1.1)  مبيعات مباشرة ",
        subtitle: `دون تدخل أي طرف وتحتسب بحسب النسبة المتفق عليها`,
      },
      {
        title: "(5.1.2) مبيعات من طرف المدرب",
        subtitle:
          "عن طريق نظام المروجين وهنا ترتفع نسبة المدرب حتى 85٪ من اجمالي مبيعات دوراته او 50٪ من اجمالي مبيعات دورات المنصة المشاركة في نظام الترويج",
      },
      {
        title: "(5.1.3) مبيعات من خلال الترويج",
        subtitle: `المروجين والاعلانات المدفوعة والحملات الترويجية من تدرب والأطراف الخارجية المدفوعة وهنا تستقطع نسبة الترويج من عملية البيع (بحد اقصى 50٪ )  وعمولات خدمات الدفع واي ضرائب مفروضة بحسب بلد المستخدم وبعدها يقسم المبلغ المتبقي بحسب الاتفاق المبرم بين المدرب والمنصة`,
      },
      {
        title: "",
        subtitle: `(5.1.4)  تقوم تدرَّب بتسديد جميع مدفوعات المُدرّب بالدينار الكويتيّ أو ما يُعادله، بغض النظر عن العُملة التي تم بها البيع، وتدرَّب غير مسؤولة عن رسوم تحويل العُملات الأجنبية أو رسوم شبكات الاتصال أو أي رسوم مُعالجة أخرى قد تتحملها، وسيقوم تقرير الإيرادات بعرض سعر المبيعات بالعُملة المحلية ومبلغ الإيرادات المُحوَّلَة بالدينار الكويتيّ`,
      },
    ],
  },
  {
    type: "sectionNumbered",
    id: null,
    title: "(2.5 استلام المدفوعات )",
    subtitle: `(5.2.1)  يتم تحويل المدفوعات بعد  45 يوم من الشهر التي تمت فيه عمليات البيع على سبيل المثال مبيعات    شهر يناير يتم تحصيلها بداية شهر مارس

(5.2.2)  يتم إيداع المدفوعات الخاصة بك في حساب بنكي نشط علماً بأن الحد الأدنى للتحويل في حسابك المصرفي هي 100 دينار كويتي  او ما يعادلة من عملات محلية`,
    subSections: [
      {
        title: "ويجب اطلاع منصة تدرب على الآتي:-",
        subtitle: `-هوية المدرب
- البريد الإلكترونيّ الصحيح المُرتبط بحسابك،
- تقديم أي معلومات تعريفية أو مُستندات ضريبية ضرورية لدفع المبالغ المُستحَقَة.

يجب عليك أن توافق على أن شركة تدرَّب تمتلك الحق في اقتطاع الضرائب المُناسبة من مدفوعاتك، وتحتفظ بالحق في حجب المدفوعات أو فرض عقوبات أخرى إذا لم تتلقَ منك معلومات تعريفية مُناسبة أو وثائق ضريبية، كما يجب أن توافق على أنك مسؤول في النهاية عن أي ضرائب على دخلك.`,
      },
      {
        title:
          "واعتمادًا على نموذج حصة الإيرادات المعمول به؛ سيتم السداد في غضون 45 يوماً من نهاية الشهر الذي: -",
        subtitle: `(أ) تتلقى فيه تدرَّب رسوم الدورة التدريبية.
(ب) حدث استهلاك لدورتك التدريبية (تدرب للشركات).

(5.2.3) بصفتك مُدرِّباً؛ فأنت مسؤول عن تحديد ما إذا كنتَ مؤهلاً للحصول على أموال من شركة تدرب، وتحتفظ تدرَّب بالحق في عدم دفع الأموال في حالات الاحتيال المُحدد أو انتهاكات حقوق الملكية الفكرية أو الانتهاكات الأخرى للقانون. 

(5.2.4) إذا لم تتمكن تدرَّب من تسوية الأموال في حساب الدفع الخاص بك بعد الفترة الزمنية التي تحددها دولتك أو بلدك أو أي سلطة حكومية أخرى في قوانين المِلكية التي لم تتم المطالبة بها؛ فقد تقوم الشركة بمُعالجة الأموال المُستَحَقة لك وفقًا لالتزاماتها القانونية، بما في ذلك تقديم تلك الأموال للسُلطة الحكومية المُختصة كما يقتضي القانون. `,
      },
    ],
  },
  {
    type: "sectionNumbered",
    id: "سادساً العلامات التجارية",
    title: "6 - سادساً العلامات التجارية",
    subtitle: `كونك مدرِّباً ناشراً صانع محتوى تخضع للمُتطلَّبات الواردة أدناه؛ يُمكنك استخدام علامات تدرَّب التجارية حيث يتم السماح لك بذلك`,
    subSections: [
      {
        title: "يجب عليك أن :",
        subtitle: `-  تستخدم صور علامات تدرَّب التجارية التي توفرها لك فقط، كما هو مُفصَّل في أي إرشادات قد تنشرها المنصة.

-  تستخدم فقط علامات تدرَّب التجارية فيما يتعلق بالترويج وبيع المحتوى المُقدَّم الخاص بك المُتاح على المنصة أو مُشاركتك من خلالها، والامتثال على الفور إذا طلبت منك تدرَّب التوقف عن الاستخدام.`,
      },
      {
        title: "ويحذر عليك أن :",
        subtitle: `-  استخدام علامات تدرَّب التجارية بطريقة مُضلِّلة أو مُهينة.

-  استخدام علامات تدرَّب التجارية بطريقة توحي بأن المنصة تُصادق أو ترعى أو توافق على المحتوى أو الخدمات المُقدَّمة الخاصة بك.

- استخدام علامات تدرَّب التجارية بطريقة تنتهك القانون المعمول به أو فيما يتعلق بموضوع أو مادة فاحشة أو غير لائقة أو غير قانونية.`,
      },
    ],
  },
  {
    type: "titleSubtitle",
    id: "الثقة والأمان",
    title: "7 - الثقة والأمان",
    subtitle: `(7.1)  تعطيل حسابك او أي دورة من دوراتك او حذف الحساب بشكل كامل يكون بالتنسيق مع فريق عمل المنصة وفي هذه الحالة تحتفظ المنصة بالمحتوى التعليمي كحق للمشتركين ولن يكون متاح للبيع الا في حالة إعادة تنشيط دورتك التدريبية مرة أخرى


(7.2)  ستبذل منصة تدرَّب جهوداً معقولة تجارياً لإجراء أي مدفوعات مُجدوَلة مُتبقية مُستَحَقَّة لك قبل تعطيل أو حذف الحساب الخاص بك ، ويجب أن تعلم أنه إذا كان المشتركين قد سجلوا مُسبقاً في المحتوى المُقدَّم الخاص بك؛ فقد يظل اسمك والمحتوى المُرسَل في مُتناول هؤلاء الطلاب بعد حذف حسابك، وإذا كنتَ بحاجة إلى مُساعدة أو واجهتَ صعوبة في حذف حسابك؛ يُمكنك الاتصال بشركة تدرَّب عبر مركز الدعم الخاص بها payment@tadarab.com عن طريق البريد الإلكترونيّ 

أو من خلال هذا الرقم 0096599002199`,
  },
  {
    type: "sectionNumbered",
    id: "شروط قانونية متنوعة",
    title: "8 - شروط قانونية متنوعة",
    subSections: [
      {
        title: "(1.8  تحديث وتعديل الشروط )",
        subtitle: `قد تقوم تدرَّب بتحديث هذه الشروط لتوضيح مُمارساتها أو إضافة مُمارسات جديدة أو مُختلفة، مثل إضافة ميزات جديدة، كما إن تدرَّب تحتفظ بالحق في تعديل  أو إجراء تغييرات على هذه الشروط، وفقًا لتقديرها الخاص في أي وقت.

يتم إخطارك  عند قيام منصة تدرَّب بإجراء أي تغيير جوهريّ باستخدام وسائل بارزة مثل إشعار البريد الإلكترونيّ المُرسَل إلى عنوان البريد الإلكترونيّ المُحدد في حسابك، أو عن طريق نشر إشعار من خلال خدمات المنصة، وستصبح التعديلات سارية المفعول في يوم نشرها ما لم يُنَص على خلاف ذلك

الاستمرار في استخدام خدمات منصة تدرَّب بعد أن تصبح التغييرات سارية المفعول؛ يعني أنك تقبل هذه التغييرات، على أن تحل أي شروط تمت مراجعتها، محل جميع الشروط السابقة`,
      },
      {
        title: "(2.8  علاقة المدرب و منصة تدرَّب )",
        subtitle:
          "يتفقان الطرفان -المدرب ومنصة تدرَّب - على عدم وجود مشروع مُشترك أو شراكة وكالة بينكما",
      },
      {
        title: "(3.8 الأقسام السارية)",
        subtitle: `يجب أن تظل الأقسام التالية سارية بعد انتهاء أو إنهاء هذه الشروط: -

* 2 (الترخيص لتدرَّب).

* 3.3 (العلاقة بالمُستخدمين الآخرين)

* 3.5 (تلقي المدفوعات)

* 7 (حذف حسابك)

* 8 (شروط قانونية متنوعة).

* 9 كيفية الاتصال بمنصة تدرَّب



أفضل طريقة للتواصل مع منصة تدرَّب؛ التواصل مع  فريق الدعم الخاص بالمدربين، والذي يسعده سماع أسئلتك وتعليقاتك حول الخدمات التي تُقدِّمها، وذلك عن طريق البريد الإلكترونيّ info@tadarab.com أو من خلال هذا الرقم 0096599002199.`,
      },
    ],
  },
  {
    type: "relatedList",
    title: "مقالات ذات صلة",
    items: [
      { id: 0, label: "الشروط والأحكام", value: "/terms" },
      { id: 1, label: "سياسة ملفات تعريف الارتباط", value: "/cookies-policy" },
      { id: 2, label: "السياسات والخصوصية", value: "/privacy-policy" },
    ],
  },
];

export const privacyTermsAndConditions = [
  {
    type: "titleSubtitle",
    id: null,
    title: "سياسة الخصوصية لموقع تدرب",
    subtitle: `لقد صيغ بيان الخصوصية لكى تعرف كيف يتعامل موقع
www.tadarab.com
.مع البيانات التي يجمعها عنك، علماً بأن إدارة الموقع قد تعدل هذه السياسة من وقت إلى آخر من دون إعلان مسبق مما يتطلب منك مراجعة هذه الصفحة بشكل منتظم
 `,
  },
  {
    type: "titledList",
    title: "جدول المحتويات",
    items: privacyTermsAndConditionsListItems,
  },
  {
    type: "titleSubtitle",
    id: "إستخدام المعلومات المجمعة",
    title: "1 - إستخدام المعلومات المجمعة",
    subtitle: `.لتفاعل مع شبكات التواصل الاجتماعي والمنصات الخارجية
.نشر ومشاركة تعليقات المتدربين، علي فيسبوك، توتير، جوجل‎
.مشاركتها مع تحليلات جوجل Google Analytic، من اجل تتبع ودراسة استخدامك لموقع تدرب ، وإعداد تقارير عن كل تفاعلاتك مع برامج ودورات الموقع .المختلفة
.التواصل معك، وإرسال الرسائل عبر بريدك الإلكتروني الذي تزودنا به أثناء استخدام صفحة “اتصل بنا”، من خلال نموذج التعليقات اسفل كل مقال أو من خلال الاشتراك في النشرة البريدية لمعمل ألوان
.السماح لك بالتعليق علي الدورات التدريبية، حيث أن حقل “البريد ألإلكتروني” في نموذج التعليقات هو حقل ضروري`,
  },
  {
    type: "titleSubtitle",
    id: "االبيانات الشخصية",
    title: "2 - البيانات الشخصية",
    subtitle: `.يقوم موفع تدرب التابع لمؤسسة الأنظمة المفتوحة بجمع البيانات لكل من الستخدمين وزوار الموقع مثل
.بيانات ملفات الارتباط “الكوكيز” بمتصفحك
.بيانات التصفح وبيانات استخدامك
.البيانات الشخصية التي تزودنا بها أثناء التفاعل مع الموقع في التعليقات مثلاً وخلافة
.بعض البيانات الأخرى عن نوعية المتصفح، البلد، وقت التصفح، مدة التصفح، الصفحات التي تزورها، وتقرير كامل عن كل مرة تزور فيها معمل ألوان`,
  },
  {
    type: "titleSubtitle",
    id: "من يطلع على بياناتك",
    title: "3 - من يطلع على بياناتك",
    subtitle: `.المؤسسة المالكة  لموقع تدرب، مؤسسة الأنظمة المفتوحة
في بعض الحالات قد يكون الوصول إلى البيانات متاحاً لأطراف خارجية (مثل مزودي الخدمات التقنية الآخرين، ومواقع البريد الإلكتروني، ومقدمي خدمات الاستضافة، وشركات تكنولوجيا المعلومات ووكالات الاتصالات)`,
  },
  {
    type: "titleSubtitle",
    id: "معلومات إضافية",
    title: "4 - معلومات إضافية",
    subtitle: `انت تتحمل المسئولية عن نشر أو مشاركة البيانات الشخصية الخاصة بالغير على موقع تدرب ويجب أن تتأكد أن لديك الحق في نشرها أو مشاركتها، مما يخلي مسؤولية موقع تدرب ومؤسسة الأنظمة المفتوحة تجاه البيانات التي تنشرها عن الغير
.موقع تدرب يتعهد باتخاذ التدابير الأمنية اللازمة لمنع استخدام البيانات التي يجمعها عنك في غير الغرض الذي جمعت من اجله
.قد يتضمن موقع تدرب وصلات إلى مواقع الأخرى، ولن يكون معمل ألوان مسؤول عن ممارسات جمع البيانات و/أو سياسات الخصوصية لأي موقع أخر`,
  },
  {
    type: "titleSubtitle",
    id: "وقت تخزين تلك البيانات",
    title: "5 - وقت تخزين تلك البيانات",
    subtitle: `.يتم الاحتفاظ بالبيانات لمدة لازمة من الوقت لضمان عمل الموقع بشكل سليم
.لا يتم حذف بعض البيانات التي نجمعها الا بطلب من المستخدم
يمكنك للمستخدم طلب حذف البيانات التى تم جمعها عن طريق التواصل مع فريق الدعم الفني عن طريق الايميل
support@tadarab.com`,
  },
  {
    type: "relatedList",
    title: "مقالات ذات صلة",
    items: [
      { id: 0, label: "الشروط والأحكام", value: "/terms" },
      { id: 1, label: "سياسة ملفات تعريف الارتباط", value: "/cookies-policy" },
    ],
  },
];

export const cookiesTermsAndConditions = [
  {
    type: "titledList",
    title: "جدول المحتويات",
    items: cookiesListItems,
  },
  {
    type: "titleSubtitle",
    id: "ما هي ملفات تعريف الارتباط؟",
    title: "1 - ما هي ملفات تعريف الارتباط؟",
    subtitle: `ملفات تعريف الارتباط هي أجزاء من البيانات، يتم تخزينها عادةً في ملفات نصية، تضعها مواقع الإنترنت على أجهزة الحاسبات الخاصة بالزوار لتخزين مجموعة من المعلومات، عادةً ما تكون خاصة بذلك الزائر - أو بالأحرى الجهاز الذي يستخدمه لعرض الموقع - مثل المتصفح أو الهاتف الجوال.
 
تم إنشاؤها للتغلب على قيود في تقنيات شبكة الإنترنت، وصفحات الإنترنت تكون عديمة الحالة؛ مما يعني أنها لا تمتلك ذاكرة، ولا يمكنها بسهولة تمرير المعلومات بين بعضها البعض؛ لذلك، توفر ملفات تعريف الارتباط نوعاً من الذاكرة لصفحات الإنترنت.
 
وتتيح لك ملفات تعريف الارتباط تسجيل الدخول على صفحة واحدة، ثم الانتقال إلى صفحات أخرى والبقاء مسجلاً للدخول؛ فهي تسمح لك بتعيين التفضيلات لعرض الصفحة؛ لتتذكرها في المرة التالية التي تعود فيها إليها.
ويمكن أيضاً استخدام ملفات تعريف الارتباط لمشاهدة الصفحات التي تزورها بين المواقع؛ مما يتيح للمعلنين تكوين صورة عن اهتماماتك، ثم عندما تهبط على موقع يعرض أحد إعلاناتهم - يمكنهم تكييفه وفقاً لتلك الاهتمامات، ويُعرف هذا باسم "الإعلان السلوكي".
 
تستخدم جميع مواقع الإنترنت تقريباً ملفات تعريف الارتباط بطريقة أو بأخرى، وكل صفحة تزورها في تلك المواقع تكتب ملفات تعريف الارتباط إلى جهاز الحاسوب الخاص بك وتستقبلها منه.
وتعد ملفات تعريف الارتباط مفيدة بشكل لا يصدق؛ فهي تسمح لمواقع الإنترنت الحديثة بالعمل بالطريقة التي يتوقعها الناس، مع كل مستويات التخصيص المتزايدة والوظائف التفاعلية الغنية.
 
ومع ذلك، مكن أيضاً استخدامها للتلاعب بتجربة تصفح المستخدم للإنترنت بطرق قد لا تتوقعها أو لا تعجبك؛ فيمكن أن يكون هذا لصالحك، أو لصالح شخص آخر، حتى الأعمال التجارية أو المنظمة التي لم يكن لديك أي اتصال مباشر بها، أو ربما سمعت عنها.
 
من المستحيل معرفة ما إذا كانت ملفات تعريف ارتباط معينة تفيدك أنت أو طرف آخر بمجرد النظر إليها؛ لذلك عليك الاعتماد على موقع الإنترنت الذي تزوره لإخبارك بكيفية استخدامه لملفات تعريف الارتباط.`,
  },
  {
    type: "titleSubtitle",
    id: "أنواع ملفات تعريف الارتباط",
    title: "2 - أنواع ملفات تعريف الارتباط",
    subtitle: `هناك العديد من الأنواع والاستخدامات المختلفة لملفات تعريف الارتباط، ولكن يمكن تصنيف معظمها بعدد من الطرق المختلفة: - `,
  },
  {
    type: "titleSubtitle",
    id: "ملفات تعريف الارتباط للطرف الأول",
    title: "3 - ملفات تعريف الارتباط للطرف الأول:",
    subtitle: `إحدى السمات الرئيسية لملف تعريف الارتباط هو "مضيفه" - وهذا هو اسم المجال الخاص بالموقع الذي يقوم في النهاية بتعيين ملف تعريف الارتباط - ويمكن للمجال المضيف فقط استرداد محتويات ملف تعريف الارتباط وقراءتها بمجرد تعيينه.
 
إذا كان اسم المضيف هو نفسه المجال الموجود في شريط عنوان المتصفح عند تعيينه أو استرداده؛ فهو إذن ملف تعريف ارتباط للطرف الأول.
 
يتم تعيين ملفات تعريف ارتباط الطرف الأول أو استردادها فقط بواسطة موقع الإنترنت أثناء زيارتك له؛ لذلك لا يمكن استخدامها عادةً لتتبع النشاط أو تمرير البيانات من موقع إلى آخر.
 
ومع ذلك، لا يزال بإمكان مالك موقع الإنترنت هذا جمع البيانات من خلال ملفات تعريف الارتباط الخاصة به واستخدامها لتغيير كيفية ظهور موقع الإنترنت للمستخدم، أو المعلومات التي يعرضها.
 
بالطبع يمكنه أيضاً جمع البيانات واستخدامها خارج موقع الإنترنت الخاص به، وحتى بيعها إلى مؤسسات أخرى، ومع ذلك، إذا فعل؛ فيجب توضيح ذلك في سياسة الخصوصية الخاصة بالموقع.
 
تسمح لك معظم متصفحات سطح المكتب بمشاهدة قائمة بملفات تعريف الارتباط التي تم تعيينها، وعادة يتم إدراجها حسب قيمة المجال المضيف.`,
  },
  {
    type: "titleSubtitle",
    id: "ملفات تعريف ارتباط الطرف الثالث",
    title: "4 - ملفات تعريف ارتباط الطرف الثالث:",
    subtitle: ` إذا كان المجال المضيف لملف تعريف الارتباط مختلفاً عن النطاق الموجود في شريط المتصفح عند تنزيله؛ فهو ملف تعريف ارتباط تابع لجهة خارجية.
 
يتم وضعها عادةً في موقع إنترنت عبر البرامج النصية أو العلامات المضافة إلى صفحة الإنترنت، وفي بعض الأحيان، ستجلب هذه البرامج النصية أيضاً وظائف إضافية إلى الموقع، مثل تمكين مشاركة المحتوى عبر الشبكات الاجتماعية.
 
على سبيل المثال؛ إذا قمت بزيارة موقع يحتوي على فيديو يوتيوب في إحدى صفحاته؛ يتم تضمين ذلك من قبل مالك الموقع، باستخدام جزء من التعليمات البرمجية المقدمة من خلاله؛ سيتمكن يوتيوب بعد ذلك من تعيين ملفات تعريف الارتباط من خلال هذا الرمز، ومعرفة أنك شاهدت هذا الفيديو، أو حتى مجرد زيارة الصفحة التي يوجد بها الفيديو.
 
يُعد الإعلان عبر الإنترنت هو الاستخدام الأكثر شيوعاً لملفات تعريف ارتباط الطرف الثالث، من خلال إضافة علاماته إلى صفحة، والتي قد تعرض إعلانات أو لا تعرضها، ويمكن للمعلنين حينها تتبع مستخدم أو جهازه عبر العديد من مواقع الإنترنت التي يزورها.
 
يتيح له ذلك إنشاء ملف تعريف سلوكي للمستخدم، والذي يمكن استخدامه بعد ذلك لاستهدافه بإعلانات عبر الإنترنت تستند إلى اهتماماته المحسوبة.
 
وغالباً ما يُنظر إلى استخدام ملفات تعريف الارتباط لهذا الغرض على أنه تدخلي وانتهاك للخصوصية، مثل هذا النشاط هو أحد الدوافع وراء تطوير قوانين الخصوصية الجديدة، ولاسيما قانون ملفات تعريف الارتباط في الاتحاد الأوروبي.`,
  },
  {
    type: "titleSubtitle",
    id: "ملفات تعريف ارتباط الجلسة",
    title: "5 - ملفات تعريف ارتباط الجلسة",
    subtitle: `يتم تخزين ملفات تعريف ارتباط الجلسة مؤقتاً فقط في ذاكرة المتصفح، ويتم إتلافها عند إغلاقها، على الرغم من أنها ستبقى موجودة أثناء التنقل بعيداً عن موقع الإنترنت الذي أتت منه.
 
وإذا كان عليك تسجيل الدخول إلى موقع إنترنت في كل مرة تفتح فيها المتصفح وتزوره؛ فهذا يعني أنه يستخدم ملف تعريف ارتباط الجلسة لتخزين بيانات اعتماد تسجيل الدخول الخاصة بك.
 
وتستخدم العديد من مواقع الإنترنت ملفات تعريف الارتباط للجلسة لوظائف الموقع الأساسية، وللتأكد من إرسال الصفحات إلى المتصفح بأسرع ما يمكن وبكفاءة.`,
  },
  {
    type: "titleSubtitle",
    id: "ملفات تعريف الارتباط الدائمة",
    title: "6 - ملفات تعريف الارتباط الدائمة",
    subtitle: `كما يوحي الاسم؛ يتم حفظ هذا النوع من ملفات تعريف الارتباط على جهاز الحاسوب الخاص بك بحيث تظل هناك عند إغلاقها وتشغيلها مرة أخرى.
 
ويتم إنشاء ملفات تعريف الارتباط الدائمة من خلال منحها تاريخ انتهاء الصلاحية، وإذا تم الوصول إلى تاريخ انتهاء الصلاحية هذا؛ فسيتم إتلافه بواسطة الحاسوب، وإذا لم يتم تعيين تاريخ انتهاء الصلاحية؛ فسيكون تلقائياً ملف تعريف ارتباط للجلسة.
 
وعادةً يتم حفظ تاريخ انتهاء الصلاحية على أنه الوقت الذي تم فيه إنشاء ملف تعريف الارتباط لأول مرة بالإضافة إلى عدد الثواني التي يحددها المبرمج الذي كتب رمز ملف تعريف الارتباط، ومع ذلك، لا يوجد حد حقيقي لتاريخ انتهاء الصلاحية؛ لذلك يمكن تعيينه ليكون 20 عاماً في المستقبل، بالإضافة إلى ذلك، إذا قمت بزيارة موقع الإنترنت الذي قدم ملف تعريف الارتباط مرة أخرى؛ فقد يضع تلقائياً إصداراً محدثاً على جهاز الحاسوب الخاص بك، مع تاريخ انتهاء صلاحية مستقبلي منقح.
 
وإذا قمت بتسجيل الدخول إلى موقع إنترنت، ثم أغلقت جهاز الحاسوب الخاص بك وأعدت تشغيله مرة أخرى، ثم عدت إلى موقع الإنترنت لتجد أنك ما زلت مسجلاً للدخول؛ فهو يستخدم ملف تعريف ارتباط دائم لتذكرك.
 
تُستخدم ملفات تعريف الارتباط الدائمة أيضاً لتتبع سلوك الزائر أثناء تنقلك في الموقع، ويتم استخدام هذه البيانات لمحاولة فهم ما يفعله الأشخاص وما لا يعجبهم في الموقع حتى يمكن تحسينه، وتُعرف هذه الممارسة باسم تحليلات الإنترنت.
 
ومنذ أن بدأ جوجل في تقديم تقنية التحليلات الخاصة بها مجاناً لأصحاب مواقع الإنترنت؛ فجميع مواقع الإنترنت تقريباً تستخدم شكلاً من أشكالها، على الرغم من وجود خدمات مدفوعة الأجر متاحة لمنافسة جوجل.
 
ومن المحتمل أن تكون ملفات تعريف الارتباط التحليلية هي الشكل الأكثر شيوعاً لملفات تعريف الارتباط الدائمة المستخدمة اليوم.
 
ومع ذلك، يمكن أن يكون لملفات تعريف الارتباط الدائمة أيضاً، فترة حياة أقصر من بعض ملفات تعريف الارتباط للجلسة؛ حيث يمكن ترميزها ليتم إتلافها في غضون ثانية أو ثانيتين من التعيين، في حين أن ملف تعريف الارتباط للجلسة سيستمر دائماً حتى تغلق متصفحك.`,
  },
  {
    type: "titleSubtitle",
    id: "ملفات تعريف الارتباط الآمنة",
    title: "7 - ملفات تعريف الارتباط الآمنة",
    subtitle: `يتم إرسال ملفات تعريف الارتباط الآمنة فقط عبر HTTPS والتي ستجدها عادةً في صفحات الخروج من مواقع التسوق عبر الإنترنت، وهذا يضمن أن أي بيانات في ملف تعريف الارتباط سيتم تشفيرها أثناء مرورها بين الموقع الإلكتروني والمتصفح.
 
وملفات تعريف الارتباط التي تستخدمها مواقع التجارة الإلكترونية لتذكر تفاصيل بطاقة الائتمان، أو إدارة عملية المعاملة بطريقة ما، عادةً تكون آمنة، ولكن أي ملف تعريف ارتباط آخر قد يكون آمناً أيضاً.`,
  },
  {
    type: "titleSubtitle",
    id: "ملفات تعريف ارتباط HTTPOnly",
    title: "8 - ملفات تعريف ارتباط HTTPOnly",
    subtitle: `عندما يحتوي ملف تعريف الارتباط على مجموعة سمات HTTPOnly؛ سيمنع المتصفح أي برنامج نصي للعميل في الصفحة- مثل JavaScript - من الوصول إلى محتويات ملف تعريف الارتباط.
وهذا يحميها مما يسمى بهجمات البرمجة النصية عبر المواقع (XSS)؛ حيث يحاول البرنامج النصي الضار إرسال محتوى ملف تعريف الارتباط إلى موقع إنترنت تابع لجهة خارجية.`,
  },
  {
    type: "titleSubtitle",
    id: "تقنيات التتبع عبر الإنترنت",
    title: "9 - تقنيات التتبع عبر الإنترنت",
    subtitle: `ملفات تعريف الارتباط هي النوع الأكثر شهرة وشائعة لتتبع تقنيات تتبع مواقع الإنترنت، ومع ذلك، تستخدم العديد من مواقع الإنترنت والمعلنين والأدوات التحليلية، أنواعاً أخرى من التقنيات لتتبع المستخدمين أو مراقبة أداء موقع الإنترنت.`,
  },
  {
    type: "titleSubtitle",
    id: "إشارات الإنترنت ووحدات البكسل",
    title: "10 - إشارات الإنترنت ووحدات البكسل",
    subtitle: `إشارة الإنترنت - التي يشار إليها غالباً باسم علامة البكسل - هي صورة GIF أو خطأ إنترنت واضح، وعادة لا تزيد عن 1 بكسل × 1 بكسل صورة شفافة، والتي يتم وضعها على موقع إنترنت أو في رسالة بريد إلكتروني؛ لمراقبة سلوك المستخدم الذي يزور الموقع أو يتلقى البريد الإلكتروني وغالباً ما يتم استخدامها مع ملفات تعريف الارتباط.
 
وتعمل إشارات الإنترنت عن طريق إرسال المعلومات مع الطلب إلى خادم الإنترنت مع الصورة.
 
على سبيل المثال؛ عندما يتصل المتصفح بموقع ما باستخدام إشارة الإنترنت، يطلب المستعرض من خادم الإنترنت تنزيل الصورة - يمكن أن يتضمن هذا الطلب تفاصيل مثل عنوان المُعرّف الرقمي IP أو نوع المتصفح أو وقت الوصول أو ملفات تعريف الارتباط التي تم تعيينها مسبقاً.
وتستخدم المواقع بشكل عام إشارات الإنترنت لفهم كيفية تصفح المستخدمين للموقع واستخدام هذه المعلومات لتقديم محتوى أكثر تخصيصاً أو جعل التصفح أكثر كفاءة وسهولة.
 
وإذا تم إيقاف تشغيل ملفات تعريف الارتباط؛ فلن تتمكن إشارات الإنترنت من تتبع المستخدم، ومع ذلك، لا يزال من الممكن استخدامها لحساب الزيارات المجهولة.`,
  },
  {
    type: "titleSubtitle",
    id: "البصمات",
    title: "11 - البصمات",
    subtitle: `تُستخدم طريقة التتبع هذه عموماً مع إشارات الإنترنت، وتكمن الفكرة وراء أخذ البصمات في أنه حتى مع إيقاف تشغيل ملفات تعريف الارتباط، يمكن أن تكون المعلومات المحددة حول جهاز المستخدم والمتصفح واللغة والمكونات الإضافية والإعدادات الأخرى كافية لتحديد مستخدم واحد.`,
  },
  {
    type: "titleSubtitle",
    id: "ملف تعريف الأرتباط الفائق",
    title: "12 - ملفات تعريف الارتباط الفائقة",
    subtitle: `عادةً ما يتم تطبيق مصطلح ملف تعريف الارتباط الفائق أو  Super Cookieأو أحياناً Supercookie على تقنيات التتبع التي ليست ملفات تعريف ارتباط HTTP عادية ويتم تخزينها بطريقة مختلفة على جهاز المستخدم.

وهذا يجعل من الصعب العثور عليها والتخلص منها؛ لأنه لا يمكن إزالتها باستخدام عناصر التحكم في الخصوصية العادية الموجودة في معظم المتصفحات.`,
  },
  {
    type: "titleSubtitle",
    id: "فوائد ملفات تعريف الارتباط",
    title: "13 - فوائد ملفات تعريف الارتباط",
    subtitle: ` تُستخدم ملفات تعريف الارتباط بعدة طرق مختلفة، والعديد منها يجعل تجربة تصفح الإنترنت أفضل بكثير، ومع ذلك، يمكن تلخيص معظم هذا في كلمة واحدة؛ التخصيص.
 
فعلى سبيل المثال؛ متجر أمازون على الإنترنت هو مثال رائع على ذلك؛ فكلما زاد استخدامك للموقع؛ زاد فهم أمازون لنوع المنتجات التي تبحث عنها وتشتريها، ويتيح ذلك له تقديم توصيات بشأن المنتجات التي قد تعجبك، والتي يمكن أن تساعد في منع البحث المكثف في مثل هذا المتجر الكبير.
 
وإذا كنت قد اشتريت من أمازون ولم تقم بتسجيل الخروج بنشاط من حسابك؛ فسوف يتذكرك عند عودتك؛ حتى إنه يرحب بك بالاسم، كما إنه يتذكر أي عناصر وضعتها في سلة التسوق الخاصة بك ولكنك لم تشتريها؛ مما يجعلها أسرع في إتمام عملية الدفع.
وبالطبع فإنه يفعل ذلك لمصلحته أيضاً؛ فكل هذا يزيد من مبيعاته، لكنه يفيد المستخدمين في نفس الوقت.
 
وفي الواقع، لن يكون التسوق عبر الإنترنت ممكناً بدون ملفات تعريف الارتباط، وإذا لم يكن لدينا ملفات تعريف الارتباط؛ فلن تتمكن من تسجيل الدخول بشكل فعال إلى موقع الإنترنت، وبدلاً من ذلك، سيتعين عليك إخباره عن هويتك في كل مرة تذهب فيها إلى صفحة جديدة؛ مما سيجعل الأمر مملاً للغاية.
 
ويمكن لملفات تعريف الارتباط تخصيص موقع إنترنت بجميع أنواع الطرق الأخرى أيضاً دون الحاجة إلى التسوق؛ فعلى سبيل المثال؛ يمكن استخدامها لتذكر أن المستخدم يفضل حجم خط أكبر من المعتاد، وقد يتذكر موقع الإنترنت الإخباري أنك تحب أنواعاً معينة من القصص وتروج لها في الصفحة الرئيسية.
 
وهناك أيضاً استخدامات أكثر دقة لملفات تعريف الارتباط التي تجلب فوائد غير ملموسة للمستخدم ولموقع الإنترنت كذلك.`,
  },
  {
    type: "titleSubtitle",
    id: "تحليلات",
    title: "14 - تحليلات",
    subtitle: `تستخدم مواقع الإنترنت ملفات تعريف الارتباط لمعرفة مدى شعبية الصفحات المختلفة لمواقعها، وأحياناً أي أجزاء من الصفحات المختلفة، وهي تفعل ذلك عن طريق تتبع كل زائر للموقع تقريباً - الصفحة التي دخل إليها، ومن أين أتى للوصول إلى هناك، والصفحات التي شاهدها، والترتيب، والروابط التي نقر عليها، والوقت الذي قضاه في كل صفحة، ونقطة الخروج من الموقع.
 
حتى أن بعض الخدمات تدعي أنها تستطيع تحديد أي جزء من الصفحة يقضي المستخدم معظم الوقت في النظر إليه، حتى بدون النقر فوق أي شيء، وهذا لأنه يمكنها تتبع مكان مؤشر الفأرة في الصفحة، ويميل العديد من المستخدمين إلى وضع المؤشر بالقرب من المكان الذي ينظرون إليه.
 
يُعرف تجميع كل هذه البيانات في معلومات مفيدة باسم "تحليلات الإنترنت"، وهو يمنح مالكي مواقع الإنترنت فهماً حقيقياً لكيفية استخدام الأشخاص لمواقعهم، وهي الصفحات الأكثر شيوعاً والأقل شيوعاً، وكيف يتغير ذلك بمرور الوقت.
 
ويؤدي القيام بذلك إلى تمكين مالكي المواقع من تحسينها، والقيام بالمزيد مما يحبه الزوار وتقليل ما لا يحبونه، كما يفيد هذا الزوار من خلال محتوى وخدمات أفضل تستهدف احتياجاتهم.
ومع ذلك، تثير ملفات تعريف الارتباط أيضاً عددًا من مخاوف الخصوصية التي يجب أن يكون الأشخاص على دراية بها.`,
  },
  {
    type: "titleSubtitle",
    id: "ملفات تعريف الارتباط والخصوصية عبر الإنترنت",
    title: "15 - ملفات تعريف الارتباط والخصوصية عبر الإنترنت",
    subtitle: `على الرغم من أن ملفات تعريف الارتباط ضرورية من نواح كثيرة للإنترنت الحديث، إلا أنه منذ إنشائها كان هناك نقاش يدور حول تأثيرها على خصوصية مستخدمي الإنترنت.
 
فهي في الأساس وسيلة لموقع إنترنت، والأشخاص الذين يمتلكون ذلك الموقع؛ لتخزين واسترداد البيانات حول المستخدم أو تفاعلهم مع الموقع، وهم يفعلون ذلك بشكل أساسي إما لتغيير ما يراه هذا الشخص، أو لتسجيل أنشطتهم؛ على سبيل المثال؛ الصفحات التي يزورها، والمدة التي يقضيها على الموقع.
 
وتعد ملفات تعريف الارتباط أساسية لتجربة الإنترنت الحديثة؛ لذلك على الرغم من أنها ليست سيئة بطبيعتها، إلا أن هناك استخدامات لها حيث تنشأ مخاوف تتعلق بالخصوصية.`,
  },
  {
    type: "titleSubtitle",
    id: "تخزين معلومات التعريف الشخصية",
    title: "16 - تخزين معلومات التعريف الشخصية",
    subtitle: `يمكن استخدام ملفات تعريف الارتباط لتخزين البيانات الشخصية؛ أي شيء من الاسم أو عنوان البريد الإلكتروني إلى معرف المستخدم الفريد الذي قد يكون مجرد سلسلة عشوائية من الأحرف والأرقام.
 
وقد تكون هذه المعلومات التي تقدمها أنت كمستخدم إلى الموقع من خلال التسجيل أو صفحات تسجيل الدخول أو نماذج الطلبات، أو قد تكون معلومات يتم تخصيصها لك بشكل فريد من خلال موقع الإنترنت.
 
وقد يكون هذا جيداً طالما أن هذه المعلومات آمنة ويتم الاحتفاظ بها مؤقتاً فقط - ولكنها غالباً ليست كذلك؛ مما يعني وجود خطر يمكن أن تعترضه البرامج الضارة - خاصة عند استخدام أجهزة الحاسبات المشتركة.`,
  },
  {
    type: "titleSubtitle",
    id: "تتبع سلوك المستخدم",
    title: "17 - تتبع سلوك المستخدم",
    subtitle: `ومع ذلك؛ فإن أكثر مخاوف الخصوصية شيوعاً لدى الأشخاص هو استخدام ملفات تعريف ارتباط الطرف الثالث لتتبعها عبر مواقع الإنترنت المختلفة، وغالباً ما تستخدم للإعلان.
 
ويتم ذلك عادةً من خلال وضع العلامات غير المرئية للمستخدم في الصفحة التي تقوم بتعيين ملفات تعريف الارتباط.
وعندما تزور موقعاً آخر بنفس العلامة؛ فإنها تُبلغ المعلن بالموقع الذي كنت تستخدمه آخر مرة عندما تم تعيين ملف تعريف الارتباط، ومن خلال تجميع المعلومات عبر العديد من المواقع، يتيح ذلك للمعلن إنشاء ملف تعريف لاهتماماتك من خلال محفوظات الاستعراض الخاصة بك، ثم تستخدم هذه المعلومات لعرض إعلانات أكثر استهدافاً لك، بناءً على اهتماماتك المتصورة.
 
وفي معظم الحالات، هي في الواقع يستهدف متصفحك وليس أنت؛ لأنها لا تعرف من أنت. ولكن نظراً لأن معظم الأشخاص يسجلون الدخول ويستخدمون نفس المتصفح بانتظام؛ فيمكن أن يكون ذا طابع شخصي للغاية.
 
وإذا سمحت لشخص آخر باستخدام جهاز الحاسوب الخاص بك دون إنشاء ملف تعريف منفصل؛ فسوف تشاهد ملفات تعريف الارتباط إعلانات مخصصة لك - والتي قد تكشف شيئاً عن سجل التصفح الخاص بك، والذي لن تكون سعيدًا بمشاركته!`,
  },
  {
    type: "titleSubtitle",
    id: "محتوى مجاني",
    title: "18 - محتوى مجاني",
    subtitle: `بالطبع، كل هذه الإعلانات تدفع مقابل الكثير من المحتوى المجاني الذي نحصل عليه على الإنترنت، ويتفهمه الكثير من الناس ويقبلونه، لكن الكثيرين لا يفعلون ذلك، خاصة أنهم يشعرون أن ذلك قد تم دون موافقتهم.
 
والمشكلة الأخرى هي أن الشركات التي تجمع هذه البيانات لا تكون عادةً الشركات التي تزور مواقع الإنترنت الخاصة بها، وهي لا تجمعها فحسب، بل تبيعها أيضاً لشركات أخرى؛ لذلك يتم جمع كل هذه البيانات وتجميعها، دون أن يدركها معظم الناس - وهذا ما يجده الناس مرفوضاً.
 
بالإضافة إلى ذلك، أصبح الكثير من تنميط هذا التعقب أكثر تعقيداً، ويرتبط أحياناً بهويات العالم الحقيقي، مثل الأسماء والعناوين؛ مما يزيد من مستوى التطفل ومخاطر الخصوصية في حالة سرقة المعلومات أو فقدها.`,
  },
  {
    type: "titleSubtitle",
    id: "لائحة الخصوصية",
    title: "19 - لائحة الخصوصية",
    subtitle: `يتطلع صانعو القانون بشكل متزايد إلى إدخال لوائح لوضع بعض السيطرة على هذا النشاط، ويُعد توجيه ملفات تعريف الارتباط في الاتحاد الأوروبي أحد الأمثلة الحديثة.
 
ويتطلب هذا من مواقع الإنترنت الإعلان عن ملفات تعريف الارتباط التي تستخدمها والحصول على موافقة من المستخدمين للقيام بذلك.
 
وعلى الرغم من أن تطبيقه غير مكتمل في الوقت الحالي، إلا أنه بدأ في زيادة وعي المستهلك، والذي بدوره يمكن أن يخلق ضغوطاً في السوق من أجل مزيد من الشفافية والاختيار.
ويتطلع الاتحاد الأوروبي أيضًا إلى تقديم لائحة جديدة منسقة لحماية البيانات، والتي قد تتطلب الكثير من استخدام ملفات تعريف ارتباط الطرف الثالث لكي تخضع لموافقة صريحة من المستخدم.`,
  },
  {
    type: "titleSubtitle",
    id: "لا تتبع",
    title: "20 - لا تتبع",
    subtitle: `إحدى أحدث المبادرات العالمية هي محاولة إنشاء معيار عدم التعقب (DNT) للإنترنت، وقد تكون هذه طريقة للأشخاص لاستخدام متصفحهم للإشارة إلى مواقع الإنترنت بأنهم لا يريدون تسجيل سلوكهم، ويجب على مواقع الإنترنت للاستجابة لذلك الطلب.
 
ومع ذلك، لا يزال هناك الكثير من الجدل حول ما يعنيه DNT في الواقع، مع مجموعات الضغط على كلا الجانبين التي تدافع عن أركانها.`,
  },
  {
    type: "titleSubtitle",
    id: "كيفية إدارة ملفات تعريف الارتباط",
    title: "21 - كيفية إدارة ملفات تعريف الارتباط",
    subtitle: `توفر جميع المتصفحات الحديثة تقريباً طرقاً للتحكم في كيفية تعامل جهاز الحاسوب الخاص بك مع ملفات تعريف الارتباط، ويتضمن ذلك القدرة على حظر جميع أنواع ملفات تعريف الارتباط أو أنواع مختلفة منها، ومنع وضعها على جهازك في المقام الأول، كما أنها تمكنك من حذف ملفات تعريف الارتباط التي لديك بالفعل، ومع ذلك، يختلف كل متصفح، ويقدم بعضها تحكماً دقيقاً أكثر من الآخر، أو على الأقل تحكماً يسهل العثور عليه. 
 
وللتحقق من الإعدادات الخاصة بك؛ انتقل إلى خيارات الإنترنت ثم خيارات متقدمة، ثم قم بالتمرير لأسفل إلى إعدادات الأمان، وستجد هناك مربع اختيار بعنوان " قم دائماً بإرسال عنوان عدم التعقب"، وإذا قمت بتحديد هذا المربع أو إلغاء تحديده؛ فستحتاج إلى إعادة تشغيل المتصفح حتى يسري التغيير.`,
  },
  {
    type: "relatedList",
    title: "مقالات ذات صلة",
    items: [
      { id: 0, label: "الشروط والأحكام", value: "/terms" },
      { id: 1, label: "السياسات والخصوصية", value: "/privacy-policy" },
    ],
  },
];
